// --------------Header-logo---------------

export const BlockboltLogo = () => {
  return (
    <svg
      width="250"
      height="33"
      viewBox="0 0 250 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.207 3.40332H44.0945V23.8734H56.5745V29.5968H38.207V3.40332Z"
        fill="#00142F"
      />
      <path
        d="M60.5977 16.5003C60.5977 10.0262 63.7652 2.95264 72.2227 2.95264C80.6402 2.95264 83.7701 10.0262 83.7701 16.5003C83.7701 22.9743 80.6402 30.0479 72.2227 30.0479C63.7652 30.0479 60.5977 22.9743 60.5977 16.5003ZM77.6602 16.5003C77.6602 12.9081 76.3577 8.64073 72.2227 8.64073C68.0127 8.64073 66.7077 13.0945 66.7077 16.5003C66.7077 20.027 68.0877 24.322 72.2227 24.322C76.2077 24.322 77.6602 19.901 77.6602 16.5003Z"
        fill="#00142F"
      />
      <path
        d="M91.0352 16.4998C91.0352 10.5497 93.9027 3.02775 102.063 3.02775C104.128 2.99363 106.154 3.59024 107.876 4.73907C109.599 5.88791 110.935 7.53514 111.71 9.46401L106.46 11.8219C105.158 9.83936 104.04 8.71585 102.065 8.71585C98.3402 8.71585 97.1476 13.0184 97.1476 16.4998C97.1476 20.092 98.6002 24.2838 102.065 24.2838C103.853 24.2838 105.195 22.8983 106.388 20.9158L111.75 22.931C109.85 27.0472 106.87 29.9668 102.065 29.9668C93.8302 29.9769 91.0352 22.9739 91.0352 16.4998Z"
        fill="#00142F"
      />
      <path
        d="M130.153 17.9206L125.153 24.2184V29.6067H119.275V3.4082H125.16V15.7517L134.883 3.4082H141.963L134.138 12.9505L143.303 29.6016H136.41L130.153 17.9206Z"
        fill="#00142F"
      />
      <path
        d="M161.072 3.40348C167.294 3.40348 169.307 6.84454 169.307 10.399C169.307 12.5704 168.114 14.6663 165.729 15.8276C168.979 16.9864 170.229 19.4929 170.229 21.9263C170.229 25.4807 167.994 29.5969 161.624 29.5969H151.199V3.39844L161.072 3.40348ZM165.357 10.5803C165.357 8.89508 164.649 6.98813 161.184 6.98813H155.074V14.2179H160.439C163.717 14.2179 165.357 12.7216 165.357 10.5803ZM166.289 22.1052C166.289 19.8984 165.209 17.8026 160.812 17.8026H155.062V25.9971H161.917C165.357 26.0047 166.289 23.9466 166.289 22.1127V22.1052Z"
        fill="#00142F"
      />
      <path
        d="M210.66 3.40332H214.533V25.8559H227.283V29.5968H210.66V3.40332Z"
        fill="#00142F"
      />
      <path
        d="M242.623 29.5968H238.751V7.14416H231.373V3.40332H250.001V7.14416H242.623V29.5968Z"
        fill="#00142F"
      />
      <path
        d="M185.358 29.239C180.336 27.2061 178.436 21.6641 178.436 16.4999C178.436 10.0259 181.416 2.95231 189.798 2.95231C190.732 2.94759 191.663 3.04643 192.576 3.24704L181.326 17.9912H189.123L185.358 29.239ZM194.251 3.76094L193.846 4.96254L190.466 15.0086H198.263L190.533 25.1454L187.033 29.7554C187.946 29.954 188.877 30.052 189.811 30.0476C198.191 30.0476 201.173 22.974 201.173 16.4999C201.161 11.3358 199.251 5.79384 194.251 3.76094Z"
        fill="url(#paint0_linear_248_571)"
      />
      <path
        d="M26.585 15.9382C28.7825 14.9306 29.4525 12.8322 29.4525 10.5121C29.4525 6.95771 27.2925 3.40328 20.81 3.40328H8.2175V8.94527H20.8475C23.0825 8.94527 23.455 10.1444 23.455 11.2276C23.455 12.6508 22.4875 13.5476 20.2525 13.5476H8.2175V29.6018H21.295C27.925 29.6018 30.31 25.5712 30.31 21.7447C30.31 19.6816 29.305 16.9862 26.585 15.9382ZM21.555 24.022H14.105V18.8579H20.55C23.715 18.8579 24.35 20.2786 24.35 21.5885C24.35 22.6365 23.68 24.022 21.555 24.022ZM20.9575 0V3.40328H17.57V0H20.9575ZM20.9575 29.5967V33H17.57V29.5967H20.9575ZM9.4575 6.76122H7V4.28244H9.45L9.4575 6.76122ZM6.225 16.1776H3.765V13.7038H6.225V16.1776ZM4.3175 11.084H2.9625V9.72366H4.3175V11.084ZM5 7.08618H4.3175V6.40603H5V7.08618ZM1.015 6.74611H0V5.72588H1.015V6.74611ZM2.015 13.2302H0.3325V11.5298H2.025L2.015 13.2302ZM7.115 9.99572H5.42V8.29534H7.115V9.99572ZM1.865 9.14427H0.5V7.78397H1.855L1.865 9.14427Z"
        fill="url(#paint1_linear_248_571)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_248_571"
          x1="178.436"
          y1="16.4999"
          x2="201.161"
          y2="16.4999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#02F4D2" />
          <stop offset="1" stopColor="#6C17FC" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_248_571"
          x1="30.31"
          y1="16.5"
          x2="0"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6C17FC" />
          <stop offset="1" stopColor="#02F4D2" />
        </linearGradient>
      </defs>
    </svg>
  );
};

// --------------Header-icons---------------

export const DashboardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79292 0.417893C10.1834 0.0273689 10.8166 0.0273689 11.2071 0.417893L20.5821 9.79289C20.8681 10.0789 20.9537 10.509 20.7989 10.8827C20.6441 11.2564 20.2795 11.5 19.875 11.5H18.7918L18.7921 14.6458L18.7923 17.7916C18.7923 18.6093 18.4675 19.3937 17.8893 19.9719C17.311 20.5501 16.5268 20.875 15.709 20.875H5.29235C4.47459 20.875 3.69034 20.5501 3.1121 19.9719C2.53388 19.3937 2.20904 18.6095 2.20901 17.7918L2.20845 11.5H1.12503C0.720567 11.5 0.355931 11.2564 0.20115 10.8827C0.0463687 10.509 0.131924 10.0789 0.417922 9.79289L9.79292 0.417893ZM3.49697 9.54228C3.90852 9.66612 4.20832 10.048 4.20836 10.4999L4.20901 17.7916C4.20901 18.0789 4.32315 18.3545 4.52631 18.5577C4.72948 18.7609 5.00503 18.875 5.29235 18.875H6.37503V13.6248C6.37503 12.8071 6.69988 12.0228 7.27812 11.4446C7.85635 10.8664 8.64061 10.5415 9.45836 10.5415H11.5417C12.3594 10.5415 13.1437 10.8664 13.7219 11.4446C14.3002 12.0228 14.625 12.8071 14.625 13.6248V18.875H15.709C15.9963 18.875 16.2719 18.7609 16.475 18.5577C16.6782 18.3545 16.7923 18.079 16.7923 17.7917L16.7917 10.5001C16.7917 10.2349 16.897 9.98048 17.0846 9.79292C17.2024 9.67509 17.3466 9.58969 17.5033 9.54249L10.5 2.53921L3.49697 9.54228ZM12.625 18.875V13.6248C12.625 13.3375 12.5109 13.062 12.3077 12.8588C12.1046 12.6556 11.829 12.5415 11.5417 12.5415H9.45836C9.17105 12.5415 8.8955 12.6556 8.69233 12.8588C8.48917 13.062 8.37503 13.3375 8.37503 13.6248V18.875H12.625Z"
        fill="#333333"
      />
    </svg>
  );
};
export const PosIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
    >
      <path
        d="M4.83211 1.87377C5.22263 1.48325 5.22263 0.850084 4.83211 0.459559C4.44158 0.069035 3.80842 0.069035 3.41789 0.459559L0.292893 3.58456C-0.0976311 3.97508 -0.0976311 4.60825 0.292893 4.99877L3.41789 8.12377C3.80842 8.5143 4.44158 8.5143 4.83211 8.12377C5.22263 7.73325 5.22263 7.10008 4.83211 6.70956L3.41421 5.29167H20.75C21.3023 5.29167 21.75 4.84395 21.75 4.29167C21.75 3.73938 21.3023 3.29167 20.75 3.29167H3.41421L4.83211 1.87377Z"
        fill="#333333"
      />
      <path
        d="M18.3321 10.8762C17.9416 10.4857 17.3084 10.4857 16.9179 10.8762C16.5274 11.2668 16.5274 11.8999 16.9179 12.2904L18.3358 13.7083H1C0.447715 13.7083 0 14.156 0 14.7083C0 15.2606 0.447715 15.7083 1 15.7083H18.3358L16.9179 17.1262C16.5274 17.5168 16.5274 18.1499 16.9179 18.5404C17.3084 18.931 17.9416 18.931 18.3321 18.5404L21.4571 15.4154C21.8476 15.0249 21.8476 14.3918 21.4571 14.0012L18.3321 10.8762Z"
        fill="#333333"
      />
    </svg>
  );
};
export const PaylinksIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8762 1.50123C11.7544 0.623022 12.9455 0.129652 14.1875 0.129652C15.4295 0.129652 16.6206 0.623022 17.4988 1.50123C18.377 2.37943 18.8703 3.57053 18.8703 4.8125C18.8703 6.05447 18.377 7.24557 17.4988 8.12377L13.3355 12.287C12.9037 12.7267 12.3887 13.0761 11.8206 13.3148C11.2508 13.5543 10.6389 13.6776 10.0208 13.6776C9.40275 13.6776 8.79089 13.5543 8.22107 13.3148C7.65125 13.0754 7.13494 12.7247 6.70238 12.2832C6.31586 11.8887 6.32232 11.2556 6.71681 10.869C7.1113 10.4825 7.74443 10.489 8.13095 10.8835C8.3773 11.1349 8.67134 11.3347 8.99586 11.471C9.32037 11.6074 9.66883 11.6776 10.0208 11.6776C10.3728 11.6776 10.7213 11.6074 11.0458 11.471C11.3703 11.3347 11.6644 11.1349 11.9107 10.8835L11.9179 10.8762L11.9179 10.8762L16.0846 6.70956C16.5877 6.20643 16.8703 5.52404 16.8703 4.8125C16.8703 4.10096 16.5877 3.41857 16.0846 2.91544C15.5814 2.41231 14.899 2.12965 14.1875 2.12965C13.476 2.12965 12.7936 2.41231 12.2904 2.91544L11.7696 3.43627C11.3791 3.8268 10.7459 3.8268 10.3554 3.43627C9.96487 3.04575 9.96487 2.41258 10.3554 2.02206L10.8762 1.50123ZM7.17941 5.68516C7.74922 5.44572 8.36109 5.32238 8.97917 5.32238C9.59725 5.32238 10.2091 5.44572 10.7789 5.68516C11.3487 5.92459 11.8651 6.27533 12.2976 6.71681C12.6841 7.1113 12.6777 7.74443 12.2832 8.13095C11.8887 8.51747 11.2556 8.51101 10.869 8.11652C10.6227 7.86509 10.3287 7.66535 10.0041 7.52899C9.67963 7.39262 9.33117 7.32238 8.97917 7.32238C8.62717 7.32238 8.27871 7.39262 7.95419 7.52899C7.62968 7.66535 7.33564 7.86509 7.08929 8.11652L7.08215 8.12381L7.08211 8.12377L2.91544 12.2904C2.41231 12.7936 2.12965 13.476 2.12965 14.1875C2.12965 14.899 2.41231 15.5814 2.91544 16.0846C3.41857 16.5877 4.10097 16.8703 4.8125 16.8703C5.52404 16.8703 6.20643 16.5877 6.70956 16.0846L7.23039 15.5637C7.62092 15.1732 8.25408 15.1732 8.64461 15.5637C9.03513 15.9543 9.03513 16.5874 8.64461 16.9779L8.12377 17.4988C7.24557 18.377 6.05447 18.8703 4.8125 18.8703C3.57053 18.8703 2.37943 18.377 1.50123 17.4988C0.623024 16.6206 0.129654 15.4295 0.129654 14.1875C0.129654 12.9455 0.623024 11.7544 1.50123 10.8762L5.66449 6.71296C6.09629 6.27329 6.61125 5.9239 7.17941 5.68516Z"
        fill="#333333"
      />
    </svg>
  );
};
export const SettingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8144 7.75288C18.8618 7.76728 18.9091 7.78169 18.9558 7.79742C20.1347 8.19456 20.8 9.2057 20.8 10.3C20.8 11.5053 20.1123 12.5387 18.976 12.9219C18.7984 12.9818 18.6125 13.0455 18.4581 13.1517C18.4387 13.165 18.4194 13.1806 18.4 13.2C18.2284 13.3716 18.1064 13.6093 18.1004 13.8518C18.1 13.8682 18.1 13.8841 18.1 13.9C18.1 14.1003 18.1937 14.2756 18.2884 14.453C18.3275 14.5262 18.3668 14.5998 18.3998 14.6756C18.8471 15.7041 18.6003 16.8997 17.8 17.7C16.9 18.6 15.5 18.8 14.4 18.1C14.2 18 14.1 18 14 18L13.9528 18.0001C13.7078 18.0018 13.4733 18.1267 13.3 18.3C13.1697 18.4303 13.1096 18.6039 13.0491 18.7788C13.0291 18.8365 13.009 18.8943 12.9864 18.9508C12.5777 19.9712 11.5698 20.7 10.4 20.7C9.22008 20.7 8.20493 20.041 7.80315 18.9472C7.78557 18.8994 7.76927 18.8499 7.75285 18.8001C7.69298 18.6183 7.63142 18.4314 7.5 18.3C7.4679 18.2679 7.43579 18.2358 7.4037 18.207C7.29164 18.1065 7.15051 18 7 18C6.89999 18 6.60001 18.1 6.39999 18.2C5.3 18.9 3.89999 18.7 3 17.8C2.10001 16.9 1.89999 15.5 2.60001 14.4C2.65265 14.2947 2.67758 14.2448 2.68938 14.1921C2.7 14.1446 2.7 14.0947 2.7 14C2.7 13.8828 2.66568 13.8 2.63725 13.7314C2.61716 13.6828 2.60001 13.6414 2.60001 13.6C2.60001 13.5 2.5 13.4 2.39999 13.3C2.3 13.2 2.2 13.1 2.10001 13.1C0.899994 12.8 0 11.7 0 10.4C0 9.14452 0.839401 8.07558 1.97778 7.73362C2.05846 7.70938 2.13721 7.67891 2.21564 7.64817L2.22205 7.64569C2.33228 7.60324 2.46663 7.5445 2.53751 7.45C2.60837 7.3555 2.65413 7.25176 2.68033 7.13658C2.7 7.05012 2.7 6.95815 2.7 6.9C2.7 6.69894 2.60844 6.52075 2.51602 6.34089C2.47853 6.26792 2.4409 6.19467 2.40918 6.11951C1.94966 5.03055 2.19441 3.8951 3 3C3.9369 2.15679 5.13713 1.92803 6.27174 2.47819C6.33672 2.5097 6.39719 2.55042 6.45755 2.59107C6.54079 2.64713 6.62384 2.70307 6.71831 2.73456C6.88333 2.78957 7.06459 2.76771 7.2 2.7C7.39999 2.6 7.60001 2.4 7.7 2.1C8 0.9 9.10001 0 10.4 0C11.5695 0 12.5772 0.728437 12.9133 1.74842C12.9285 1.79454 12.9425 1.84223 12.9567 1.89036C13.0112 2.07583 13.0677 2.26768 13.2 2.4C13.3671 2.56705 13.6104 2.69506 13.8466 2.69962C13.8663 2.7 13.8844 2.7 13.9 2.7C14.1003 2.7 14.2756 2.60635 14.4529 2.51161C14.5262 2.47248 14.5998 2.43317 14.6756 2.40019C15.7041 1.95292 16.8997 2.19972 17.7 3C18.6 4 18.8 5.3 18.1 6.4C18 6.6 18 6.7 18 6.8C18 6.81562 18 6.83369 18.0004 6.85343C18.0049 7.08962 18.1329 7.33295 18.3 7.5C18.4386 7.63861 18.6261 7.69561 18.8144 7.75288ZM16.9 11.7C17.3 11.4 17.7 11.2 18.1 11.1C18.7 11 18.8 10.5 18.8 10.4C18.8 10.2 18.8 9.7 18.2 9.6C17.7 9.5 17.3 9.3 17 9C16.6 8.7 16.4 8.4 16.2 8C16 7.6 16 7.1 16 6.7C16 6.2 16.2 5.8 16.5 5.5C16.8 5 16.5 4.6 16.4 4.5C16.3 4.4 15.9 4.1 15.4 4.4C15.1 4.6 14.6 4.8 14.2 4.8C13.7 4.8 13.3 4.8 12.9 4.6C12.4 4.4 12.1 4.1 11.8 3.8C11.5 3.4 11.3 3 11.2 2.6C11 2 10.5 2 10.4 2C10.2 2 9.7 2 9.60001 2.6C9.39999 3.5 8.8 4.2 8 4.5C7.10001 4.9 6.2 4.8 5.39999 4.4C4.89999 4.1 4.5 4.4 4.39999 4.5C4.3 4.6 4 5 4.3 5.5C4.5 5.8 4.7 6.3 4.7 6.7C4.7 7.1 4.7 7.6 4.5 8C4.39999 8.4 4.10001 8.7 3.8 9C3.39999 9.3 3 9.5 2.60001 9.6C2 9.8 2 10.3 2 10.4C2 10.5 2 11 2.60001 11.1C3.10001 11.2 3.5 11.4 3.8 11.7C4.19997 12 4.39996 12.4 4.59996 12.7999L4.60001 12.8C4.8 13.2 4.8 13.7 4.8 14.1C4.8 14.5 4.60001 14.9 4.39999 15.3C4.10001 15.8 4.39999 16.2 4.5 16.3C4.60001 16.4 5 16.7 5.5 16.4C5.8 16.2 6.3 16 6.7 16H6.89999C7.2 16 7.60001 16.1 7.89999 16.2C8.39999 16.4 8.7 16.7 9 17C9.16022 17.1602 9.2919 17.3489 9.37984 17.5662C9.43057 17.6915 9.46252 17.8297 9.4942 17.9667C9.56325 18.2652 9.631 18.5581 9.88901 18.7005C10.0694 18.8 10.2451 18.8 10.3 18.8C10.5 18.8 11 18.8 11.1 18.2C11.2 17.7 11.4 17.3 11.7 17C12 16.6 12.4 16.4 12.8 16.2C13.2 16 13.7 16 14.1 16C14.5 16 14.9 16.2 15.3 16.4C15.8 16.7 16.2 16.4 16.3 16.3C16.4 16.2 16.7 15.8 16.4 15.3C16.2 15 16 14.5 16 14.1C16 13.6 16 13.2 16.1 12.8C16.3 12.3 16.6 12 16.8999 11.7L16.9 11.7ZM6.3 10.4C6.3 8.2 8.10001 6.3 10.4 6.3C12.6 6.3 14.5 8.2 14.5 10.4C14.5 12.6 12.6 14.5 10.4 14.5C8.2 14.5 6.3 12.6 6.3 10.4ZM8.3 10.4C8.3 11.5 9.2 12.5 10.4 12.5C11.5 12.5 12.5 11.5 12.5 10.4C12.5 9.3 11.5 8.3 10.4 8.3C9.3 8.3 8.3 9.3 8.3 10.4Z"
        fill="#333333"
      />
    </svg>
  );
};
export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02809 1.06975C1.60632 0.491516 2.39058 0.166666 3.20833 0.166666H10.5C11.3178 0.166666 12.102 0.491517 12.6802 1.06975C13.2585 1.64799 13.5833 2.43225 13.5833 3.25V5.33333C13.5833 5.88562 13.1356 6.33333 12.5833 6.33333C12.031 6.33333 11.5833 5.88562 11.5833 5.33333V3.25C11.5833 2.96268 11.4692 2.68713 11.266 2.48397C11.0629 2.2808 10.7873 2.16667 10.5 2.16667H3.20833C2.92102 2.16667 2.64547 2.2808 2.4423 2.48397C2.23914 2.68713 2.125 2.96268 2.125 3.25V15.75C2.125 16.0373 2.23914 16.3129 2.4423 16.516C2.64547 16.7192 2.92102 16.8333 3.20833 16.8333H10.5C10.7873 16.8333 11.0629 16.7192 11.266 16.516C11.4692 16.3129 11.5833 16.0373 11.5833 15.75V13.6667C11.5833 13.1144 12.031 12.6667 12.5833 12.6667C13.1356 12.6667 13.5833 13.1144 13.5833 13.6667V15.75C13.5833 16.5678 13.2585 17.352 12.6802 17.9302C12.102 18.5085 11.3178 18.8333 10.5 18.8333H3.20833C2.39058 18.8333 1.60632 18.5085 1.02809 17.9302C0.44985 17.352 0.125 16.5678 0.125 15.75V3.25C0.125 2.43225 0.44985 1.64799 1.02809 1.06975ZM16.0429 5.66789C16.4334 5.27737 17.0666 5.27737 17.4571 5.66789L20.5821 8.79289C20.9726 9.18342 20.9726 9.81658 20.5821 10.2071L17.4571 13.3321C17.0666 13.7226 16.4334 13.7226 16.0429 13.3321C15.6524 12.9416 15.6524 12.3084 16.0429 11.9179L17.4608 10.5H5.29167C4.73939 10.5 4.29167 10.0523 4.29167 9.5C4.29167 8.94772 4.73939 8.5 5.29167 8.5H17.4608L16.0429 7.08211C15.6524 6.69158 15.6524 6.05842 16.0429 5.66789Z"
        fill="#333333"
      />
    </svg>
  );
};

// --------------dashboard-header-icons---------------

export const BalanceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="22"
      viewBox="0 0 14 22"
      fill="none"
    >
      <path
        d="M6.08523 21.8182V0H7.48295V21.8182H6.08523ZM10.1165 6.98011C10.0369 6.2358 9.7017 5.65625 9.1108 5.24148C8.52557 4.82671 7.7642 4.61932 6.8267 4.61932C6.16761 4.61932 5.60227 4.71875 5.13068 4.91761C4.65909 5.11648 4.2983 5.38636 4.0483 5.72727C3.7983 6.06818 3.67045 6.45739 3.66477 6.89489C3.66477 7.25852 3.74716 7.57386 3.91193 7.84091C4.08239 8.10796 4.3125 8.33523 4.60227 8.52273C4.89205 8.70455 5.21307 8.85796 5.56534 8.98296C5.91761 9.10796 6.27273 9.21307 6.63068 9.2983L8.26705 9.70739C8.92614 9.8608 9.55966 10.0682 10.1676 10.3295C10.7812 10.5909 11.3295 10.9205 11.8125 11.3182C12.3011 11.7159 12.6875 12.196 12.9716 12.7585C13.2557 13.321 13.3977 13.9801 13.3977 14.7358C13.3977 15.7585 13.1364 16.6591 12.6136 17.4375C12.0909 18.2102 11.3352 18.8153 10.3466 19.2528C9.36364 19.6847 8.1733 19.9006 6.77557 19.9006C5.41761 19.9006 4.23864 19.6903 3.23864 19.2699C2.24432 18.8494 1.46591 18.2358 0.903409 17.429C0.346591 16.6222 0.0454546 15.6392 0 14.4801H3.1108C3.15625 15.0881 3.34375 15.5938 3.6733 15.9972C4.00284 16.4006 4.43182 16.7017 4.96023 16.9006C5.49432 17.0994 6.09091 17.1989 6.75 17.1989C7.4375 17.1989 8.03977 17.0966 8.55682 16.892C9.07955 16.6818 9.48864 16.392 9.78409 16.0227C10.0795 15.6477 10.2301 15.2102 10.2358 14.7102C10.2301 14.2557 10.0966 13.8807 9.83523 13.5852C9.57386 13.2841 9.20739 13.0341 8.7358 12.8352C8.26989 12.6307 7.72443 12.4489 7.09943 12.2898L5.11364 11.7784C3.67614 11.4091 2.53977 10.8494 1.70455 10.0994C0.875 9.34375 0.460227 8.34091 0.460227 7.09091C0.460227 6.0625 0.738636 5.16193 1.29545 4.38921C1.85795 3.61648 2.62216 3.01705 3.58807 2.59091C4.55398 2.15909 5.64773 1.94318 6.86932 1.94318C8.10795 1.94318 9.19318 2.15909 10.125 2.59091C11.0625 3.01705 11.7983 3.6108 12.3324 4.37216C12.8665 5.12784 13.142 5.99716 13.1591 6.98011H10.1165Z"
        fill="white"
      />
    </svg>
  );
};
export const DocumentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
    >
      <path
        d="M3.60511 12.5625V12.3409C3.6108 11.3125 3.70739 10.4943 3.89489 9.88636C4.08807 9.27841 4.3608 8.78977 4.71307 8.42045C5.06534 8.04545 5.49432 7.7017 6 7.3892C6.34659 7.1733 6.65625 6.9375 6.92898 6.68182C7.20739 6.42045 7.42614 6.13068 7.58523 5.8125C7.74432 5.48864 7.82386 5.12784 7.82386 4.73011C7.82386 4.28125 7.71875 3.89205 7.50852 3.5625C7.2983 3.23295 7.0142 2.97727 6.65625 2.79546C6.30398 2.61364 5.90909 2.52273 5.47159 2.52273C5.06818 2.52273 4.68466 2.6108 4.32102 2.78693C3.96307 2.95739 3.66477 3.21875 3.42614 3.57102C3.19318 3.91761 3.0625 4.35795 3.03409 4.89205H0C0.0284091 3.8125 0.289773 2.90909 0.784091 2.18182C1.28409 1.45455 1.94318 0.909091 2.76136 0.545454C3.58523 0.181818 4.49432 0 5.48864 0C6.57386 0 7.52841 0.190341 8.35227 0.571023C9.18182 0.951705 9.8267 1.49432 10.2869 2.19886C10.7528 2.89773 10.9858 3.72727 10.9858 4.6875C10.9858 5.33523 10.8807 5.91477 10.6705 6.42614C10.4659 6.9375 10.1733 7.39205 9.79261 7.78977C9.41193 8.1875 8.96023 8.54261 8.4375 8.85511C7.97727 9.1392 7.59943 9.43466 7.30398 9.74148C7.0142 10.0483 6.7983 10.4091 6.65625 10.8239C6.51989 11.233 6.44886 11.7386 6.44318 12.3409V12.5625H3.60511ZM5.08807 17.8807C4.5767 17.8807 4.13636 17.6989 3.76705 17.3352C3.39773 16.9716 3.21307 16.5284 3.21307 16.0057C3.21307 15.4943 3.39773 15.0568 3.76705 14.6932C4.13636 14.3295 4.5767 14.1477 5.08807 14.1477C5.59375 14.1477 6.03125 14.3295 6.40057 14.6932C6.77557 15.0568 6.96307 15.4943 6.96307 16.0057C6.96307 16.3523 6.875 16.6676 6.69886 16.9517C6.52841 17.2358 6.30114 17.4631 6.01705 17.6335C5.73864 17.7983 5.42898 17.8807 5.08807 17.8807Z"
        fill="white"
      />
    </svg>
  );
};

// -------------paylinks-modal-icons----------------

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.542893 0.542893C0.933417 0.152369 1.56658 0.152369 1.95711 0.542893L7.5 6.08579L13.0429 0.542893C13.4334 0.152369 14.0666 0.152369 14.4571 0.542893C14.8476 0.933417 14.8476 1.56658 14.4571 1.95711L8.91421 7.5L14.4571 13.0429C14.8476 13.4334 14.8476 14.0666 14.4571 14.4571C14.0666 14.8476 13.4334 14.8476 13.0429 14.4571L7.5 8.91421L1.95711 14.4571C1.56658 14.8476 0.933417 14.8476 0.542893 14.4571C0.152369 14.0666 0.152369 13.4334 0.542893 13.0429L6.08579 7.5L0.542893 1.95711C0.152369 1.56658 0.152369 0.933417 0.542893 0.542893Z"
        fill="#333333"
      />
    </svg>
  );
};

// -------------setting-page-icons----------------

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C8.55228 0 9 0.447715 9 1V7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H9V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V9H1C0.447715 9 0 8.55228 0 8C0 7.44772 0.447715 7 1 7H7V1C7 0.447715 7.44772 0 8 0Z"
        fill="#fff"
      />
    </svg>
  );
};
export const CancelIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.343133 0.343146C0.733658 -0.0473782 1.36682 -0.0473782 1.75735 0.343146L5.99999 4.58579L10.2426 0.343146C10.6332 -0.0473785 11.2663 -0.0473782 11.6568 0.343146C12.0474 0.73367 12.0474 1.36684 11.6568 1.75736L7.4142 6L11.6568 10.2426C12.0474 10.6332 12.0474 11.2663 11.6568 11.6569C11.2663 12.0474 10.6332 12.0474 10.2426 11.6569L5.99999 7.41421L1.75735 11.6569C1.36682 12.0474 0.733658 12.0474 0.343133 11.6569C-0.0473908 11.2663 -0.0473909 10.6332 0.343133 10.2426L4.58577 6L0.343133 1.75736C-0.0473909 1.36684 -0.0473908 0.73367 0.343133 0.343146Z"
        fill="#333333"
      />
    </svg>
  );
};

// -------------Payment-page-icons----------------

export const EthIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11Z"
        fill="black"
      />
      <path
        d="M11.0186 15.2058V19.2742L15.9996 12.2401L11.0186 15.2058Z"
        fill="#9B9B9B"
      />
      <path
        d="M11.019 3L15.9999 11.2889L11.019 14.2546L6 11.2889"
        fill="#9A9A9A"
      />
      <path
        d="M11.019 3V9.00755L6 11.2889M6 12.2395L11.0186 15.2058V19.2742"
        fill="#FCFCFC"
      />
      <path d="M11.0186 9.00497V14.2521L15.9996 11.2863" fill="#333333" />
      <path d="M6 11.2863L11.0186 9.00497V14.2521" fill="#999999" />
    </svg>
  );
};
export const BinanceNewIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
      <path
        d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z"
        fill="#F0B90B"
      />
      <path
        d="M21.2258 30.0573L17.6129 33.6703L14 30.0573L17.6129 26.4445L21.2258 30.0573ZM30 21.2258L36.1936 27.4194L39.8064 23.8064L30 14L20.1935 23.8064L23.8064 27.4194L30 21.2258ZM42.3871 26.3871L38.7742 30L42.3871 33.6129L46 30L42.3871 26.3871ZM30 38.8315L23.8064 32.5806L20.1935 36.1936L30 46.0573L39.8064 36.2509L36.1936 32.638L30 38.8315ZM30 33.6129L33.6129 30L30 26.3871L26.3871 30L30 33.6129Z"
        fill="white"
      />
    </svg>
  );
};
export const BaseIcon = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
      <path
        d="M30 60C35.9334 60 41.7336 58.2405 46.6671 54.9441C51.6006 51.6476 55.4458 46.9624 57.7164 41.4804C59.9871 35.9987 60.5811 29.9668 59.4236 24.1474C58.266 18.3279 55.4087 12.9824 51.2132 8.78681C47.0177 4.59124 41.6721 1.73401 35.8526 0.576456C30.0332 -0.581102 24.0013 0.0129988 18.5195 2.28362C13.0377 4.55426 8.35236 8.39944 5.05592 13.3329C1.75947 18.2664 0 24.0666 0 30C0 37.9566 3.16071 45.5871 8.78679 51.2132C14.4129 56.8393 22.0434 60 30 60Z"
        fill="#0052FF"
      />
      <path
        d="M29.9295 51.1268C41.5974 51.1268 51.0563 41.6681 51.0563 30C51.0563 18.3321 41.5974 8.87329 29.9295 8.87329C18.8603 8.87329 9.77929 17.3862 8.87642 28.2221H40.227V31.7402H8.87329C9.75816 42.5942 18.8473 51.1268 29.9295 51.1268Z"
        fill="white"
      />
    </svg>
  );
};
export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7071 0.292893C17.0976 0.683417 17.0976 1.31658 16.7071 1.70711L6.70711 11.7071C6.31658 12.0976 5.68342 12.0976 5.29289 11.7071L0.292893 6.70711C-0.0976311 6.31658 -0.0976311 5.68342 0.292893 5.29289C0.683417 4.90237 1.31658 4.90237 1.70711 5.29289L6 9.58579L15.2929 0.292893C15.6834 -0.0976311 16.3166 -0.0976311 16.7071 0.292893Z"
        fill="#333333"
      />
    </svg>
  );
};
export const CryptoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
    >
      <path
        d="M14.5774 9.04962C14.2978 7.26907 13.4874 5.78528 12.1235 4.60966C11.9408 4.44986 11.8781 4.32431 11.9465 4.08462C12.1634 3.28566 12.3517 2.48098 12.5572 1.68202C12.6028 1.50511 12.5914 1.4138 12.3803 1.36814C11.7411 1.22547 11.1019 1.06567 10.4742 0.894467C10.2858 0.843105 10.2231 0.900174 10.1831 1.07709C10.0347 1.70485 9.86353 2.33261 9.72086 2.96036C9.6752 3.14869 9.60672 3.18864 9.42981 3.13157C9.20724 3.05738 8.97325 3.00031 8.73927 2.96036C8.53382 2.92612 8.47675 2.85764 8.53382 2.64078C8.69932 2.03585 8.83058 1.42521 8.99608 0.820278C9.05886 0.597709 8.99037 0.523519 8.78493 0.477864C8.16287 0.335192 7.54653 0.181106 6.93019 0.0213125C6.74186 -0.0300495 6.67338 0.00419182 6.62201 0.203933C6.42798 1.02573 6.21112 1.84181 6.01708 2.66931C5.97143 2.86905 5.87441 2.93754 5.68608 2.98319C2.87258 3.67943 0.955067 5.38579 0.241705 8.22212C-0.471657 11.0699 0.418619 13.4839 2.58724 15.4356C2.72991 15.5612 2.76415 15.6696 2.7185 15.8522C2.50164 16.6797 2.30189 17.5129 2.09074 18.3404C2.05079 18.5059 2.07362 18.5744 2.25053 18.6144C2.90112 18.7628 3.546 18.9225 4.18517 19.0995C4.3792 19.1508 4.43057 19.088 4.47051 18.9111C4.61889 18.2834 4.78439 17.6556 4.93277 17.0279C4.97843 16.8395 5.05262 16.8053 5.22953 16.8624C5.47493 16.9423 5.72603 17.005 5.97713 17.045C6.15976 17.0792 6.17688 17.142 6.13122 17.3132C5.96001 17.9467 5.81734 18.5858 5.64613 19.2193C5.59477 19.4076 5.64613 19.4647 5.82305 19.5047C6.46793 19.6587 7.11851 19.8128 7.75769 19.984C7.9346 20.0297 7.98025 19.9783 8.0202 19.8185C8.21424 19.0082 8.4311 18.1978 8.61943 17.3817C8.6765 17.142 8.78493 17.0507 9.02462 16.9936C10.7938 16.5941 12.2091 15.6525 13.2934 14.1972C13.4246 14.0203 13.4132 13.9633 13.1907 13.9119C12.4944 13.7521 11.8039 13.5809 11.1133 13.3983C10.925 13.3469 10.8109 13.3754 10.6568 13.5067C9.07027 14.8649 7.2726 15.1788 5.3722 14.3513C3.48893 13.5352 2.54729 12.0058 2.45027 10.2937C2.43886 7.40604 4.539 5.24883 7.08998 5.19176C9.32708 5.1404 11.1476 6.37309 11.9351 8.47322C11.9865 8.61019 12.0493 8.69579 12.1976 8.73003C12.911 8.90124 13.6187 9.07245 14.3263 9.26078C14.5717 9.32926 14.6117 9.2836 14.5774 9.04962Z"
        fill="#F0B90B"
      />
    </svg>
  );
};
export const BinanceIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.50805 10.0179L2.25402 12.2719L0 10.0179L2.25402 7.76389L4.50805 10.0179ZM9.98211 4.50805L13.8462 8.37211L16.1002 6.11806L9.98211 0L3.86404 6.11806L6.11805 8.37211L9.98211 4.50805ZM17.7102 7.72811L15.4562 9.98211L17.7102 12.2361L19.9642 9.98211L17.7102 7.72811ZM9.98211 15.4919L6.11805 11.5921L3.86404 13.8462L9.98211 20L16.1002 13.8819L13.8462 11.6279L9.98211 15.4919ZM9.98211 12.2361L12.2361 9.98211L9.98211 7.72811L7.72811 9.98211L9.98211 12.2361Z"
        fill="#F0B90B"
      />
    </svg>
  );
};
export const SuiIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.48 8.352C13.312 9.376 13.76 10.656 13.76 12.064C13.76 13.472 13.248 14.816 12.416 15.84L12.352 15.904V15.776C12.352 15.712 12.288 15.584 12.288 15.456C11.84 13.6 10.496 12.064 8.256 10.784C6.72 9.952 5.888 8.864 5.632 7.712C5.504 6.944 5.568 6.176 5.824 5.536C6.016 4.896 6.336 4.32 6.592 4L7.488 2.912C7.616 2.72 7.936 2.72 8.064 2.912L12.48 8.352ZM13.888 7.264L8.064 0.096C7.936 -0.032 7.744 -0.032 7.616 0.096L1.728 7.264C0.64 8.608 0 10.336 0 12.192C0 16.48 3.52 20 7.808 20C12.096 20 15.616 16.544 15.616 12.192C15.616 10.336 14.976 8.608 13.888 7.264ZM3.136 8.288L3.648 7.648V7.776C3.648 7.84 3.648 7.968 3.712 8.032C4.032 9.824 5.248 11.296 7.296 12.448C9.024 13.472 10.048 14.624 10.368 15.84C10.496 16.352 10.496 16.864 10.432 17.312C9.664 17.696 8.768 17.888 7.808 17.888C4.48 17.888 1.856 15.2 1.856 11.936C1.792 10.656 2.304 9.312 3.136 8.288Z"
        fill="#4CA3FF"
      />
    </svg>
  );
};
export const AptosIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.4097 6.64646H13.6408C13.4367 6.64646 13.2326 6.5444 13.0966 6.40834L12.3822 5.59191C12.1781 5.35379 11.8039 5.35379 11.5998 5.5579L11.5658 5.59191L10.9535 6.27223C10.7494 6.5104 10.4773 6.64646 10.1711 6.64646H0.510258C0.238121 7.42886 0.0680343 8.27926 0 9.12965H9.11656C9.28662 9.12965 9.42268 9.06165 9.52474 8.9596L10.3412 8.07514C10.4432 7.97308 10.5793 7.90508 10.7494 7.90508H10.7834C10.9535 7.90508 11.0895 7.97308 11.1916 8.10914L11.9059 8.9256C12.042 9.09565 12.2461 9.16371 12.4502 9.16371H19.8659C19.7979 8.31326 19.6278 7.49685 19.3556 6.68046H15.4097V6.64646ZM5.47674 14.3003C5.64679 14.3003 5.78291 14.2322 5.88497 14.1302L6.73537 13.2457C6.83742 13.1437 6.97348 13.0757 7.14359 13.0757H7.17759C7.34765 13.0757 7.48376 13.1437 7.58576 13.2798L8.30016 14.0962C8.43622 14.2662 8.64034 14.3343 8.84439 14.3343H18.9134C19.2876 13.5519 19.5598 12.7015 19.7299 11.851H10.069C9.86491 11.851 9.66085 11.749 9.52474 11.6129L8.81039 10.7965C8.70834 10.6605 8.53828 10.5924 8.40222 10.5924C8.23211 10.5924 8.09605 10.6605 7.99399 10.7965L7.38171 11.4769C7.17759 11.715 6.90542 11.817 6.59931 11.817H0.102052C0.272138 12.6674 0.544275 13.5179 0.918463 14.3003H5.47674ZM12.6203 3.9591C12.7904 3.9591 12.9264 3.89106 13.0285 3.78901L13.8789 2.90457C13.981 2.80252 14.1171 2.73448 14.2871 2.73448H14.3211C14.4912 2.73448 14.6273 2.80252 14.7294 2.93859L15.4437 3.75499C15.5798 3.89106 15.7839 3.99311 15.988 3.99311H17.893C14.5933 -0.429095 8.30016 -1.31354 3.91195 2.02013C3.16358 2.59842 2.48324 3.24474 1.93897 3.99311H12.6203V3.9591ZM8.77639 16.7835H6.15708C5.95297 16.7835 5.74885 16.6814 5.61279 16.5454L4.89845 15.729C4.69434 15.4909 4.32016 15.4909 4.08204 15.695L4.04802 15.729L3.43571 16.4433C3.23161 16.6814 2.95948 16.8175 2.65333 16.8175H2.61931C6.39519 20.8655 12.6883 21.0697 16.7363 17.3278C16.9064 17.1577 17.0765 16.9876 17.2466 16.8175L8.77639 16.7835Z"
        fill="black"
      />
    </svg>
  );
};
export const SolanaIcon = () => {
  return (
    <svg
      width="101"
      height="88"
      viewBox="0 0 101 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100.48 69.3817L83.8068 86.8015C83.4444 87.1799 83.0058 87.4816 82.5185 87.6878C82.0312 87.894 81.5055 88.0003 80.9743 88H1.93563C1.55849 88 1.18957 87.8926 0.874202 87.6912C0.558829 87.4897 0.31074 87.2029 0.160416 86.8659C0.0100923 86.529 -0.0359181 86.1566 0.0280382 85.7945C0.0919944 85.4324 0.263131 85.0964 0.520422 84.8278L17.2061 67.408C17.5676 67.0306 18.0047 66.7295 18.4904 66.5234C18.9762 66.3172 19.5002 66.2104 20.0301 66.2095H99.0644C99.4415 66.2095 99.8104 66.3169 100.126 66.5183C100.441 66.7198 100.689 67.0067 100.84 67.3436C100.99 67.6806 101.036 68.0529 100.972 68.415C100.908 68.7771 100.737 69.1131 100.48 69.3817ZM83.8068 34.3032C83.4444 33.9248 83.0058 33.6231 82.5185 33.4169C82.0312 33.2108 81.5055 33.1045 80.9743 33.1048H1.93563C1.55849 33.1048 1.18957 33.2121 0.874202 33.4136C0.558829 33.6151 0.31074 33.9019 0.160416 34.2388C0.0100923 34.5758 -0.0359181 34.9482 0.0280382 35.3103C0.0919944 35.6723 0.263131 36.0083 0.520422 36.277L17.2061 53.6968C17.5676 54.0742 18.0047 54.3752 18.4904 54.5814C18.9762 54.7875 19.5002 54.8944 20.0301 54.8952H99.0644C99.4415 54.8952 99.8104 54.7879 100.126 54.5864C100.441 54.3849 100.689 54.0981 100.84 53.7612C100.99 53.4242 101.036 53.0518 100.972 52.6897C100.908 52.3277 100.737 51.9917 100.48 51.723L83.8068 34.3032ZM1.93563 21.7905H80.9743C81.5055 21.7907 82.0312 21.6845 82.5185 21.4783C83.0058 21.2721 83.4444 20.9704 83.8068 20.592L100.48 3.17219C100.737 2.90357 100.908 2.56758 100.972 2.2055C101.036 1.84342 100.99 1.47103 100.84 1.13408C100.689 0.79713 100.441 0.510296 100.126 0.308823C99.8104 0.107349 99.4415 1.24074e-05 99.0644 0L20.0301 0C19.5002 0.000878397 18.9762 0.107699 18.4904 0.313848C18.0047 0.519998 17.5676 0.821087 17.2061 1.19848L0.524723 18.6183C0.267681 18.8866 0.0966198 19.2223 0.0325185 19.5839C-0.0315829 19.9456 0.0140624 20.3177 0.163856 20.6545C0.31365 20.9913 0.561081 21.2781 0.875804 21.4799C1.19053 21.6817 1.55886 21.7896 1.93563 21.7905Z"
        fill="url(#paint0_linear_174_4403)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_174_4403"
          x1="8.52558"
          y1="90.0973"
          x2="88.9933"
          y2="-3.01622"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#9945FF" />
          <stop offset="0.3" stopColor="#8752F3" />
          <stop offset="0.5" stopColor="#5497D5" />
          <stop offset="0.6" stopColor="#43B4CA" />
          <stop offset="0.72" stopColor="#28E0B9" />
          <stop offset="0.97" stopColor="#19FB9B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const VenomIcon = () => {
  return (
    <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.406.04a3.282 3.282 0 0 0-1.543.132 3.14 3.14 0 0 0-1.287.82c-.668.71-.876 1.636-.716 2.563.146.837.338 1.686.382 2.492a8.735 8.735 0 0 1-.572 3.568c-.397 1.033-.961 1.834-2.172 2.011-.09.014-.416.023-.51.028a4.166 4.166 0 0 1-.476-.027c-1.21-.177-1.78-.978-2.176-2.018a8.734 8.734 0 0 1-.572-3.568c.044-.803.236-1.653.382-2.491.16-.928-.048-1.854-.715-2.565A3.142 3.142 0 0 0 4.14.168 3.283 3.283 0 0 0 2.594.04C1.043.28.01 1.589 0 2.962a2.735 2.735 0 0 0 .437 1.5c.483.758 1.276 1.31 1.968 1.883.458.383 1.25 1.47 1.638 2.649.235.714.426 1.437.616 2.167.266 1.018.632 3.266.873 4.286.481 2.043 1.954 2.506 3.43 2.553h.052c1.476-.047 2.973-.51 3.454-2.554.24-1.02.605-3.269.873-4.286.19-.726.381-1.453.616-2.167.389-1.179 1.18-2.27 1.638-2.65.692-.574 1.484-1.124 1.968-1.881.29-.452.441-.972.437-1.5C17.992 1.584 16.962.274 15.406.04Z"
        fill="#333333"
      />
    </svg>
  );
};
export const SolanaUsdcIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C15.5417 20 20 15.5417 20 10C20 4.4583 15.5417 0 10 0C4.4583 0 0 4.4583 0 10C0 15.5417 4.4583 20 10 20ZM7.875 15.9583C4.625 14.7917 2.9583 11.1667 4.1667 7.9583C4.7917 6.2083 6.1667 4.875 7.875 4.25C8.0417 4.1667 8.125 4.0417 8.125 3.8333V3.25C8.125 3.0833 8.0417 2.9583 7.875 2.9167C7.8333 2.9167 7.75 2.9167 7.7083 2.9583C3.75 4.2083 1.5833 8.4167 2.8333 12.375C3.5833 14.7083 5.375 16.5 7.7083 17.25C7.875 17.3333 8.0417 17.25 8.0833 17.0833C8.125 17.0417 8.125 17 8.125 16.9167V16.3333C8.125 16.2083 8 16.0417 7.875 15.9583ZM12.2917 2.9583C12.125 2.875 11.9583 2.9583 11.9167 3.125C11.875 3.1667 11.875 3.2083 11.875 3.2917V3.875C11.875 4.0417 12 4.2083 12.125 4.2917C15.375 5.4583 17.0417 9.0833 15.8333 12.2917C15.2083 14.0417 13.8333 15.375 12.125 16C11.9583 16.0833 11.875 16.2083 11.875 16.4167V17C11.875 17.1667 11.9583 17.2917 12.125 17.3333C12.1667 17.3333 12.25 17.3333 12.2917 17.2917C16.25 16.0417 18.4167 11.8333 17.1667 7.875C16.4167 5.5 14.5833 3.7083 12.2917 2.9583ZM10.125 9.4167C11.875 9.625 12.75 10.125 12.75 11.5833C12.75 12.7083 11.9167 13.5833 10.6667 13.7917V14.7917C10.625 15 10.5 15.125 10.3333 15.125H9.7083C9.5 15.0833 9.375 14.9583 9.375 14.7917V13.7917C8 13.5833 7.3333 12.8333 7.1667 11.7917V11.75C7.1667 11.5833 7.2917 11.4583 7.4583 11.4583H8.1667C8.2917 11.4583 8.4167 11.5417 8.4583 11.7083C8.5833 12.3333 8.9583 12.7917 10.0417 12.7917C10.8333 12.7917 11.4167 12.3334 11.4167 11.6667C11.4167 11 11.0417 10.75 9.875 10.5417C8.125 10.3333 7.2917 9.7917 7.2917 8.4167C7.2917 7.375 8.0833 6.5417 9.3333 6.375V5.4167C9.375 5.2083 9.5 5.0833 9.6667 5.0833H10.2917C10.5 5.125 10.625 5.25 10.625 5.4167V6.4167C11.5833 6.5 12.3333 7.2083 12.5 8.125V8.1667C12.5 8.3333 12.375 8.4583 12.2083 8.4583H11.5417C11.4167 8.4583 11.2917 8.375 11.25 8.25C11.0417 7.625 10.625 7.375 9.875 7.375C9.0417 7.375 8.625 7.7499 8.625 8.3333C8.625 8.9167 8.875 9.25 10.125 9.4167Z"
        fill="#2775CA"
      />
    </svg>
  );
};
export const ICPIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="20"
      viewBox="0 0 40 20"
      fill="none"
    >
      <path
        d="M30.2113 0C27.9867 0 25.5506 1.21246 22.9811 3.604C21.7686 4.72748 20.7008 5.95106 19.9221 6.9188C19.9221 6.9188 21.168 8.35373 22.5361 9.89989C23.2814 8.96552 24.3382 7.69744 25.5729 6.55172C27.8532 4.41602 29.3437 3.9822 30.2002 3.9822C33.4038 3.9822 36.0067 6.67408 36.0067 10C36.0067 13.2925 33.4038 15.9844 30.2002 16.0178C30.0445 16.0178 29.8665 15.9955 29.644 15.9511C30.5784 16.3849 31.5907 16.6963 32.5361 16.6963C38.4093 16.6963 39.5662 12.6363 39.6329 12.3471C39.7998 11.6018 39.8999 10.8231 39.8999 10.0222C39.8888 4.49388 35.5506 0 30.2113 0Z"
        fill="url(#paint0_linear_835_76)"
      />
      <path
        d="M9.68854 20C11.9132 20 14.3493 18.7875 16.9188 16.396C18.1313 15.2725 19.1991 14.0489 19.9778 13.0812C19.9778 13.0812 18.7319 11.6463 17.3637 10.1001C16.6185 11.0345 15.5617 12.3026 14.327 13.4483C12.0467 15.5617 10.5451 16.0178 9.69967 16.0178C6.49611 16.0178 3.89321 13.3259 3.89321 10C3.89321 6.70745 6.49611 4.01557 9.69967 3.9822C9.85539 3.9822 10.0334 4.00445 10.2558 4.04894C9.32147 3.61513 8.30923 3.30367 7.36374 3.30367C1.49054 3.29255 0.333704 7.35261 0.266963 7.65295C0.100111 8.39822 0 9.17686 0 9.97775C0 15.5061 4.33815 20 9.68854 20Z"
        fill="url(#paint1_linear_835_76)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1602 6.64071C13.515 6.0178 10.3782 3.47052 7.37486 3.38153C2.01334 3.24805 0.444933 7.14127 0.300328 7.64182C1.33481 3.28142 5.16129 0.0222469 9.69966 0C13.4038 0 17.1524 3.63737 19.9221 6.9188L19.9333 6.90767C19.9333 6.90767 21.1791 8.3426 22.5473 9.88877C22.5473 9.88877 24.1046 11.7241 25.7508 13.337C26.396 13.96 29.5217 16.4739 32.525 16.5628C38.0311 16.7186 39.5551 12.6029 39.6329 12.2914C38.6207 16.6852 34.7831 19.9555 30.2225 19.9778C26.5183 19.9778 22.7697 16.3404 19.9889 13.059C19.9889 13.0701 19.9778 13.0701 19.9778 13.0812C19.9778 13.0812 18.7319 11.6463 17.3637 10.1001C17.3749 10.1001 15.8176 8.25361 14.1602 6.64071Z"
        fill="#29ABE2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_835_76"
          x1="10.1494"
          y1="1.89825"
          x2="24.5851"
          y2="26.165"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#F15A24" />
          <stop offset="0.6841" stopColor="#FBB03B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_835_76"
          x1="29.7574"
          y1="18.1044"
          x2="15.3218"
          y2="-6.16225"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#ED1E79" />
          <stop offset="0.8929" stopColor="#522785" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const CkETHIcon = () => {
  return (
    <svg
      width="513"
      height="513"
      viewBox="0 0 513 513"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="256.836" cy="256.59" r="256" fill="#3200B0" />
      <path
        d="M239.354 328.482L221.572 399.799L339.629 298.264L239.354 328.482Z"
        fill="#AE9DE5"
      />
      <path
        d="M292.695 114.531L343.781 281.6L243.506 311.819L168.488 237.895"
        fill="#AE9DE3"
      />
      <path
        d="M292.695 114.531L266.439 219.84L168.488 237.895M164.334 254.558L239.351 328.482L221.57 399.798"
        fill="white"
      />
      <path
        d="M266.441 219.841L243.508 311.819L343.783 281.601"
        fill="#6037C1"
      />
      <path
        d="M168.488 237.895L266.439 219.84L243.506 311.819"
        fill="#AD9DE2"
      />
      <path
        d="M37.2258 223.993C21.2282 330.9 85.1888 434.616 188.695 467.882L194.031 446.482C102.297 416.25 45.492 324.415 58.6833 229.343L37.2258 223.993Z"
        fill="url(#paint0_linear_3814_2287)"
      />
      <path
        d="M444.586 325.559C411.599 415.696 318.329 470.113 223.14 453.74L217.804 475.14C324.813 494.361 429.978 432.813 466.043 330.909L444.586 325.559Z"
        fill="#28AEE4"
      />
      <path
        d="M474.143 302.01C497.491 190.678 432.618 79.8919 324.976 45.2965L319.641 66.6967C415.502 98.2893 473.221 197.152 452.779 296.684L474.143 302.01Z"
        fill="url(#paint1_linear_3814_2287)"
      />
      <path
        d="M43.6421 194.674C75.2942 85.4127 184.585 18.0502 295.868 38.039L290.532 59.4391C191.06 42.3297 93.684 102.523 65.0057 200.001L43.6421 194.674Z"
        fill="#28AEE4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3814_2287"
          x1="256.836"
          y1="34.5371"
          x2="256.836"
          y2="478.642"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#79267C" />
          <stop offset="1" stop-color="#F21968" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3814_2287"
          x1="256.836"
          y1="34.5371"
          x2="256.836"
          y2="478.642"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FE621E" />
          <stop offset="1" stop-color="#FFAF42" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const CkBTCIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.08147 12.2815C9.22962 11.6148 9.39259 10.9333 9.55555 10.2519C9.65202 10.2741 9.74808 10.2951 9.84352 10.316C10.3197 10.4202 10.7804 10.5211 11.2 10.7556C11.437 10.8741 11.6593 10.9926 11.7926 11.2296C12.1037 11.7481 11.837 12.3704 11.2593 12.5185C10.9185 12.5926 10.5926 12.5926 10.2518 12.5333C10.0259 12.4972 9.79446 12.4445 9.56423 12.3921C9.41705 12.3586 9.27036 12.3252 9.12592 12.2963C9.1111 12.2963 9.09629 12.2963 9.08147 12.2815Z"
        fill="url(#paint0_linear_759_383)"
      />
      <path
        d="M10.205 9.43401C10.0645 9.40383 9.92249 9.37332 9.77777 9.34815C9.79259 9.28889 9.79258 9.25926 9.79258 9.24444C9.85067 8.99918 9.90595 8.75673 9.96087 8.51586C10.032 8.20386 10.1025 7.89452 10.1778 7.58518C10.2074 7.51111 10.237 7.4963 10.3111 7.51111C10.3644 7.52341 10.4177 7.53543 10.471 7.54744C10.8026 7.62221 11.1327 7.69663 11.4518 7.83704C11.6889 7.94074 11.8963 8.05926 12.0444 8.28148C12.3111 8.6963 12.1926 9.39259 11.5111 9.52593C11.2741 9.57037 11.0222 9.57037 10.7704 9.54074C10.5829 9.51517 10.3954 9.47489 10.205 9.43401Z"
        fill="url(#paint1_linear_759_383)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM12.437 5.39259C12.4444 5.35926 12.4518 5.32593 12.4593 5.28889C12.3894 5.27226 12.3196 5.25638 12.2501 5.24058C12.01 5.18597 11.7738 5.13228 11.5555 5.05185C11.437 5.54072 11.3185 6.02965 11.2 6.53333C11.0741 6.5037 10.9518 6.47407 10.8296 6.44444C10.7074 6.41481 10.5852 6.38518 10.4593 6.35555C10.4676 6.33892 10.4712 6.32228 10.4754 6.30302C10.4787 6.28798 10.4824 6.27134 10.4889 6.25185C10.534 6.06494 10.5763 5.88082 10.6183 5.6983C10.6727 5.46128 10.7266 5.22694 10.7852 4.99259C10.7852 4.97037 10.7889 4.95185 10.7926 4.93333C10.7963 4.91481 10.8 4.8963 10.8 4.87407C10.6444 4.83704 10.4926 4.8 10.3407 4.76296C10.1889 4.72593 10.037 4.68889 9.88147 4.65185C9.76296 5.14074 9.64444 5.64444 9.52592 6.16296C9.2148 6.08889 8.90739 6.01481 8.59998 5.94074C8.29257 5.86666 7.98517 5.79259 7.67407 5.71852C7.58518 6.05926 7.5111 6.38518 7.43703 6.71111C7.52591 6.73086 7.60163 6.75061 7.67735 6.77037C7.71521 6.78024 7.75307 6.79012 7.79259 6.8L8.14814 6.88889C8.45925 6.97778 8.59259 7.2 8.51851 7.52593C8.2074 8.82963 7.89629 10.1481 7.58518 11.4667C7.58518 11.4815 7.58147 11.4926 7.57777 11.5037C7.57407 11.5148 7.57036 11.5259 7.57036 11.5407C7.5111 11.763 7.34814 11.8519 7.14073 11.8074C6.96307 11.763 6.77062 11.7186 6.57815 11.6742L6.57777 11.6741C6.56296 11.6741 6.54444 11.6704 6.52592 11.6667C6.5074 11.663 6.48888 11.6593 6.47407 11.6593C6.32592 12 6.17777 12.3556 6.02962 12.7111L7.89629 13.1556C7.77778 13.674 7.65927 14.1777 7.54076 14.6814L8.47407 14.9037L8.82962 13.3926C9.06666 13.4519 9.3037 13.5111 9.55555 13.5704C9.47654 13.916 9.39753 14.2485 9.31852 14.581C9.27901 14.7473 9.2395 14.9136 9.19999 15.0815C9.41728 15.1309 9.62139 15.1802 9.82551 15.2296C9.92757 15.2543 10.0296 15.279 10.1333 15.3037C10.1407 15.2889 10.1444 15.2704 10.1481 15.2518C10.1518 15.2333 10.1555 15.2148 10.163 15.2C10.2373 14.8406 10.322 14.4915 10.4085 14.1355C10.4254 14.066 10.4423 13.9961 10.4593 13.9259C10.4814 13.8522 10.4851 13.8151 10.5053 13.8002C10.5256 13.7851 10.5626 13.7925 10.6518 13.8074C11.1555 13.8815 11.6444 13.9407 12.1481 13.8667C12.7111 13.7926 13.1555 13.5407 13.4667 13.0667C13.6741 12.7556 13.8074 12.4 13.8518 12.0148C13.8667 11.8074 13.8815 11.5852 13.837 11.3926C13.763 10.9481 13.4667 10.6519 13.1111 10.4148C13.0845 10.3989 13.056 10.3829 13.0263 10.3663C12.9732 10.3366 12.9162 10.3047 12.8593 10.2667C12.9333 10.237 12.9778 10.2222 13.037 10.2074C13.2148 10.1481 13.3778 10.0444 13.5259 9.91111C13.7778 9.67407 13.8963 9.36296 13.9704 9.02222C14.0889 8.37037 13.8963 7.83704 13.363 7.42222C13.0074 7.15555 12.6074 6.99259 12.1926 6.84444C12.1185 6.82963 12.1037 6.8 12.1185 6.72593C12.1359 6.65651 12.1532 6.58751 12.1705 6.51879C12.2565 6.17682 12.3408 5.8417 12.4148 5.49629C12.4222 5.45926 12.4296 5.42592 12.437 5.39259Z"
        fill="url(#paint2_linear_759_383)"
      />
      <path
        d="M17.837 9.46667C17.5704 5.57037 14.4296 2.42963 10.5333 2.16296L10.5926 1.27407C14.9333 1.57037 18.4296 5.06667 18.7259 9.40741L17.837 9.46667Z"
        fill="url(#paint3_linear_759_383)"
      />
      <path
        d="M2.16296 9.46667L1.27407 9.40741C1.57037 5.06667 5.06666 1.57037 9.4074 1.27407L9.46666 2.16296C5.57037 2.41482 2.42963 5.55556 2.16296 9.46667Z"
        fill="url(#paint4_linear_759_383)"
      />
      <path
        d="M9.4074 18.7259C5.06666 18.4296 1.57037 14.9333 1.27407 10.5926L2.16296 10.5333C2.42963 14.4296 5.57037 17.5704 9.46666 17.837L9.4074 18.7259Z"
        fill="url(#paint5_linear_759_383)"
      />
      <path
        d="M10.5926 18.7259L10.5333 17.837C14.4296 17.5704 17.5704 14.4296 17.837 10.5333L18.7259 10.5926C18.4296 14.9333 14.9333 18.4296 10.5926 18.7259Z"
        fill="url(#paint6_linear_759_383)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_759_383"
          x1="20"
          y1="9.99999"
          x2="0"
          y2="9.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00558659" stopColor="#3B01B4" />
          <stop offset="1" stopColor="#3E00B5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_759_383"
          x1="20"
          y1="9.99999"
          x2="0"
          y2="9.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00558659" stopColor="#3B01B4" />
          <stop offset="1" stopColor="#3E00B5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_759_383"
          x1="20"
          y1="9.99999"
          x2="0"
          y2="9.99999"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.00558659" stopColor="#3B01B4" />
          <stop offset="1" stopColor="#3E00B5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_759_383"
          x1="-0.000759494"
          y1="9.99222"
          x2="20.0036"
          y2="9.99222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAB146" />
          <stop offset="1" stopColor="#DE4C3F" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_759_383"
          x1="-0.00253165"
          y1="9.99013"
          x2="19.9953"
          y2="9.99013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2BA1E2" />
          <stop offset="1" stopColor="#24ABE7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_759_383"
          x1="-0.00358047"
          y1="10.0042"
          x2="19.9847"
          y2="10.0042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#522688" />
          <stop offset="1" stopColor="#B01594" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_759_383"
          x1="10.5398"
          y1="14.6343"
          x2="18.7272"
          y2="14.6343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2BA1E2" />
          <stop offset="1" stopColor="#24ABE7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const JupIcon = () => {
  return (
    <svg
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.1464 199.614C36.7084 214.305 50.2565 226.598 65.9023 235.686C81.5482 244.774 98.9383 250.452 116.932 252.348C107.675 238.417 94.218 225.6 77.4183 215.842C60.6186 206.084 42.8275 200.754 26.1464 199.614Z"
        fill="url(#paint0_linear_13278_146915)"
      />
      <path
        d="M99.9925 176.988C67.6261 158.185 32.5947 153.393 7.52861 161.858C9.94843 169.856 13.1398 177.599 17.0576 184.979C38.8358 184.475 62.6138 190.39 84.7394 203.241C106.865 216.092 123.787 233.828 134.143 253C142.499 252.743 150.811 251.679 158.963 249.822C153.896 223.858 132.35 195.796 99.9925 176.988Z"
        fill="url(#paint1_linear_13278_146915)"
      />
      <path
        d="M254.229 100.663C250.113 83.925 242.668 68.1877 232.336 54.3909C222.004 40.5942 208.997 29.0209 194.093 20.3621C179.189 11.7034 162.693 6.13675 145.59 3.99461C128.487 1.85247 111.128 3.17875 94.5489 7.89426C122.246 11.2839 152.99 21.6814 183.14 39.1972C213.291 56.7129 237.573 78.2665 254.229 100.663Z"
        fill="url(#paint2_linear_13278_146915)"
      />
      <path
        d="M213.93 162.049C199.753 138.505 175.467 115.959 145.55 98.5793C115.632 81.1992 84.0242 71.2719 56.5727 70.6152C32.4219 70.0432 14.296 77.0639 6.85584 89.8723C6.81347 89.9486 6.75415 90.0206 6.70754 90.0969C6.0381 92.4992 5.46187 94.9058 4.93648 97.3209C15.3256 93.2195 27.3629 90.9358 40.7476 90.6816C70.5124 90.1223 103.824 99.6428 134.563 117.502C165.302 135.361 190.093 159.592 204.346 185.717C210.736 197.488 214.723 209.076 216.303 220.147C218.142 218.503 219.947 216.804 221.697 215.037C221.743 214.957 221.773 214.872 221.82 214.787C229.26 201.966 226.383 182.747 213.93 162.049Z"
        fill="url(#paint3_linear_13278_146915)"
      />
      <path
        d="M122.788 137.754C76.9736 111.137 26.3458 106.968 2 125.543C2.04782 131.357 2.49231 137.161 3.3304 142.915C10.4921 140.744 17.8732 139.377 25.3373 138.839C52.5431 136.792 82.5368 144.372 109.755 160.193C136.974 176.014 158.43 198.326 170.132 222.956C173.367 229.703 175.834 236.792 177.488 244.09C182.902 241.967 188.167 239.48 193.245 236.646C197.321 206.292 168.616 164.375 122.788 137.754Z"
        fill="url(#paint4_linear_13278_146915)"
      />
      <path
        d="M237.496 122.641C223.158 99.1218 198.659 76.5132 168.53 59.0187C138.401 41.5241 106.67 31.4401 79.1295 30.6308C58.1352 30.0249 41.8736 35.1135 33.4419 44.7273C68.4522 38.7955 114.631 48.7651 159.391 74.7676C204.15 100.77 235.699 135.954 247.876 169.303C252.05 157.224 248.419 140.577 237.496 122.641Z"
        fill="url(#paint5_linear_13278_146915)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_13278_146915"
          x1="169.969"
          y1="53.7813"
          x2="54.0834"
          y2="253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_13278_146915"
          x1="169.969"
          y1="53.7813"
          x2="54.0834"
          y2="253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_13278_146915"
          x1="169.969"
          y1="53.7813"
          x2="54.0834"
          y2="253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_13278_146915"
          x1="169.969"
          y1="53.7813"
          x2="54.0834"
          y2="253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_13278_146915"
          x1="169.969"
          y1="53.7813"
          x2="54.0834"
          y2="253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_13278_146915"
          x1="169.969"
          y1="53.7813"
          x2="54.0834"
          y2="253"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor="#A4D756" />
          <stop offset="1" stopColor="#00B6E7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.70711 0.292893C6.09763 0.683417 6.09763 1.31658 5.70711 1.70711L3.41421 4H15C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6H3.41421L5.70711 8.29289C6.09763 8.68342 6.09763 9.31658 5.70711 9.70711C5.31658 10.0976 4.68342 10.0976 4.29289 9.70711L0.292893 5.70711C-0.0976311 5.31658 -0.0976311 4.68342 0.292893 4.29289L4.29289 0.292893C4.68342 -0.0976311 5.31658 -0.0976311 5.70711 0.292893Z"
        fill="black"
      />
    </svg>
  );
};

// --------------Merchant-page-icons---------------

export const CategoryIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 1.5C2.50736 1.5 1.5 2.50736 1.5 3.75C1.5 4.99264 2.50736 6 3.75 6C4.99264 6 6 4.99264 6 3.75C6 2.50736 4.99264 1.5 3.75 1.5ZM0 3.75C0 1.67893 1.67893 0 3.75 0C5.82107 0 7.5 1.67893 7.5 3.75C7.5 5.82107 5.82107 7.5 3.75 7.5C1.67893 7.5 0 5.82107 0 3.75ZM10 0.75C10 0.335786 10.3358 0 10.75 0H16.75C17.1642 0 17.5 0.335786 17.5 0.75V6.75C17.5 7.16421 17.1642 7.5 16.75 7.5H10.75C10.3358 7.5 10 7.16421 10 6.75V0.75ZM11.5 1.5V6H16V1.5H11.5ZM0 10.75C0 10.3358 0.335786 10 0.75 10H6.75C7.16421 10 7.5 10.3358 7.5 10.75V16.75C7.5 17.1642 7.16421 17.5 6.75 17.5H0.75C0.335786 17.5 0 17.1642 0 16.75V10.75ZM1.5 11.5V16H6V11.5H1.5ZM13.75 11.5C12.5074 11.5 11.5 12.5074 11.5 13.75C11.5 14.9926 12.5074 16 13.75 16C14.9926 16 16 14.9926 16 13.75C16 12.5074 14.9926 11.5 13.75 11.5ZM10 13.75C10 11.6789 11.6789 10 13.75 10C15.8211 10 17.5 11.6789 17.5 13.75C17.5 15.8211 15.8211 17.5 13.75 17.5C11.6789 17.5 10 15.8211 10 13.75Z"
        fill="#333333"
      />
    </svg>
  );
};
export const FilterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33811 0.0563508C1.44446 0.019052 1.55635 0 1.66905 0H14.6691C14.7818 0 14.8936 0.019052 15 0.0563508C15.288 0.157368 15.5491 0.322973 15.7633 0.540479C15.9774 0.757986 16.1389 1.02162 16.2355 1.31119C16.332 1.60076 16.361 1.90858 16.3201 2.21108C16.2793 2.51358 16.1698 2.80272 16 3.05635C15.9726 3.09732 15.9422 3.13619 15.909 3.17267L11.1691 8.38661V15C11.1691 15.3788 10.955 15.725 10.6163 15.8944C10.2775 16.0638 9.87207 16.0273 9.56905 15.8L5.56905 12.8C5.31725 12.6111 5.16905 12.3148 5.16905 12V8.38661L0.429113 3.17267C0.395951 3.1362 0.365532 3.09732 0.338105 3.05635C0.168286 2.80272 0.0587762 2.51358 0.0179612 2.21108C-0.0228538 1.90859 0.00610915 1.60077 0.102633 1.31119C0.199158 1.02162 0.360681 0.757985 0.574829 0.540479C0.788978 0.322973 1.05007 0.157368 1.33811 0.0563508ZM2.06597 2L6.90899 7.32733C7.07633 7.5114 7.16905 7.75123 7.16905 8V11.5L9.16905 13V8C9.16905 7.75123 9.26177 7.5114 9.42911 7.32733L14.2721 2H2.06597Z"
        fill="#333333"
      />
    </svg>
  );
};
export const CheckOutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79067 0.25C5.83522 0.25 4.25001 1.83521 4.25001 3.79067V5.18808C3.00681 5.19898 2.31526 5.26828 1.83259 5.70879C1.25982 6.23153 1.1808 7.09485 1.02277 8.82148L0.720695 12.122C0.516536 14.3526 0.414457 15.4679 0.669281 16.3639C1.09887 17.8743 2.21309 19.0952 3.67806 19.6606C4.54706 19.996 5.66704 19.996 7.907 19.996C10.147 19.996 11.2669 19.996 12.1359 19.6606C13.6009 19.0952 14.7151 17.8743 15.1447 16.3639C15.3995 15.4679 15.2975 14.3526 15.0933 12.122V12.122L14.7912 8.82147C14.6332 7.09485 14.5542 6.23153 13.9814 5.70879C13.4694 5.24153 12.7224 5.19194 11.3313 5.18667V3.79066C11.3313 1.83521 9.74613 0.25 7.79067 0.25ZM9.83134 6.68605V7.98C9.83134 8.39421 10.1671 8.73 10.5813 8.73C10.9956 8.73 11.3313 8.39421 11.3313 7.98V6.68684C11.9332 6.68934 12.3321 6.69946 12.6376 6.73899C12.8138 6.76179 12.903 6.7886 12.9438 6.80447C12.9615 6.81138 12.9689 6.81576 12.9698 6.8163L12.9702 6.81673L12.9707 6.81717C12.9713 6.81799 12.9764 6.82491 12.9849 6.84198C13.0044 6.88116 13.0392 6.96752 13.078 7.14092C13.163 7.52127 13.2148 8.05474 13.2975 8.95819L13.5995 12.2587C13.7034 13.3929 13.7742 14.1747 13.7917 14.7864C13.809 15.388 13.7692 15.717 13.7019 15.9535C13.4012 17.0108 12.6213 17.8654 11.5958 18.2612C11.3664 18.3498 11.0424 18.4194 10.4417 18.4571C9.83095 18.4954 9.04594 18.496 7.907 18.496C6.76806 18.496 5.98305 18.4954 5.3723 18.4571C4.77161 18.4194 4.44764 18.3498 4.21821 18.2612C3.19272 17.8654 2.41277 17.0108 2.11206 15.9535C2.04478 15.717 2.00502 15.388 2.02225 14.7864C2.03978 14.1747 2.11064 13.3929 2.21445 12.2587L2.51653 8.95819C2.59922 8.05474 2.65099 7.52128 2.73602 7.14092C2.77478 6.96752 2.80961 6.88116 2.82914 6.84198C2.83763 6.82493 2.84267 6.818 2.84329 6.81717L2.84376 6.81673L2.84424 6.8163C2.84512 6.81577 2.85247 6.81138 2.87023 6.80447C2.91103 6.7886 3.00021 6.76179 3.17642 6.73899C3.44074 6.70479 3.77496 6.69261 4.25001 6.68832V7.98C4.25001 8.39421 4.58579 8.73 5.00001 8.73C5.41422 8.73 5.75001 8.39421 5.75001 7.98V6.68605H9.83134ZM9.83134 5.18605V3.79066C9.83134 2.66364 8.9177 1.75 7.79067 1.75C6.66365 1.75 5.75001 2.66364 5.75001 3.79067V5.18605H9.83134Z"
        fill="#333333"
      />
    </svg>
  );
};
export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.84871 15.3729 11.551 14.3199 12.9056L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L12.9056 14.3199C11.551 15.3729 9.84871 16 8 16C3.58172 16 0 12.4183 0 8Z"
        fill="#333333"
      />
    </svg>
  );
};
export const WalletIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0.25C2.27065 0.25 1.57118 0.539731 1.05546 1.05546C0.539731 1.57118 0.25 2.27065 0.25 3V15C0.25 15.7293 0.539731 16.4288 1.05546 16.9445C1.57118 17.4603 2.27065 17.75 3 17.75H15C15.4641 17.75 15.9092 17.5656 16.2374 17.2374C16.5656 16.9092 16.75 16.4641 16.75 16V13.75H17C17.4142 13.75 17.75 13.4142 17.75 13V9C17.75 8.58579 17.4142 8.25 17 8.25H16.75V6C16.75 5.53587 16.5656 5.09075 16.2374 4.76256C15.9092 4.43437 15.4641 4.25 15 4.25H14.75V2C14.75 1.53587 14.5656 1.09075 14.2374 0.762563C13.9092 0.434375 13.4641 0.25 13 0.25H3ZM15.25 8.25V6C15.25 5.93369 15.2237 5.87011 15.1768 5.82322C15.1299 5.77634 15.0663 5.75 15 5.75H3C2.56137 5.75 2.13355 5.64521 1.75 5.44949V15C1.75 15.3315 1.8817 15.6495 2.11612 15.8839C2.35054 16.1183 2.66848 16.25 3 16.25H15C15.0663 16.25 15.1299 16.2237 15.1768 16.1768C15.2237 16.1299 15.25 16.0663 15.25 16V13.75H13C12.2707 13.75 11.5712 13.4603 11.0555 12.9445C10.5397 12.4288 10.25 11.7293 10.25 11C10.25 10.2707 10.5397 9.57118 11.0555 9.05546C11.5712 8.53973 12.2707 8.25 13 8.25H15.25ZM16.25 12.25V9.75H13C12.6685 9.75 12.3505 9.8817 12.1161 10.1161C11.8817 10.3505 11.75 10.6685 11.75 11C11.75 11.3315 11.8817 11.6495 12.1161 11.8839C12.3505 12.1183 12.6685 12.25 13 12.25H16.25ZM2.11612 3.88388C1.8817 3.64946 1.75 3.33152 1.75 3C1.75 2.66848 1.8817 2.35054 2.11612 2.11612C2.35054 1.8817 2.66848 1.75 3 1.75H13C13.0663 1.75 13.1299 1.77634 13.1768 1.82322C13.2237 1.87011 13.25 1.93369 13.25 2V4.25H3C2.66848 4.25 2.35054 4.1183 2.11612 3.88388Z"
        fill="#333333"
      />
    </svg>
  );
};
export const StarterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="50"
      viewBox="0 0 51 50"
      fill="none"
    >
      <path
        d="M6.45535 45.2494C5.04717 46.5964 3.70022 47.8974 2.35328 49.1831C2.03184 49.4739 1.69511 49.7954 1.29714 49.9331C0.99102 50.0403 0.470608 50.025 0.25632 49.8413C0.042033 49.6576 -0.0651107 49.1219 0.042033 48.8311C0.225708 48.3107 0.547139 47.8056 0.929795 47.3923C2.13899 46.076 3.40941 44.8055 4.67982 43.4892C4.11349 42.8004 3.54716 42.1269 3.02675 41.4382C1.95531 40.0147 1.00633 38.5147 0.485914 36.8004C0.363464 36.3718 0.271627 35.9126 0.241014 35.4534C0.149177 34.1983 0.883876 33.3871 2.15429 33.4177C2.70532 33.433 3.25634 33.5401 3.77676 33.6932C4.35839 33.8769 4.90942 34.1371 5.46044 34.3973C6.50127 34.8718 7.37372 35.4687 7.78699 36.6626C8.0625 37.4432 8.65945 38.132 9.08802 38.8208C9.65435 38.3004 10.1595 37.8412 10.6186 37.4126C10.1288 36.4636 9.59313 35.6065 9.21047 34.6728C8.42985 32.7748 8.24618 30.8156 8.99618 28.8717C9.7615 26.836 11.2615 25.6115 13.3432 25.1064C13.5881 25.0452 13.9554 25.1523 14.1544 25.3207C15.6697 26.5452 17.1391 27.8156 18.6391 29.0707C19.1442 28.5809 19.6187 28.0911 20.1544 27.5707C19.5728 27.0809 19.0218 26.6064 18.4554 26.1319C16.634 24.6013 14.7972 23.0707 12.9758 21.5247C11.9962 20.6982 11.9656 19.9635 12.8534 19.0757C14.7207 17.2084 16.5881 15.3563 18.4401 13.4737C18.731 13.1675 19.0065 13.0604 19.435 13.1216C21.2871 13.3512 23.1545 13.5349 25.0065 13.7492C25.1596 13.7645 25.2973 13.8104 25.481 13.841C25.6647 15.9992 26.3535 17.9737 27.6086 19.7033C28.1137 19.2135 28.6035 18.739 29.1392 18.2186C27.8382 16.1982 27.3178 13.9635 27.731 11.5451C28.0525 9.63179 28.9249 7.97872 30.2872 6.58585C32.6443 4.16747 37.2056 2.60623 41.8893 5.34605C41.9811 5.20829 42.0577 5.00931 42.2107 4.85625C43.4505 3.55522 44.7056 2.26949 45.9608 0.983767C46.8179 0.111312 47.8434 -0.240732 49.0373 0.172537C50.2924 0.616417 50.7669 1.76439 50.1241 2.92766C49.8026 3.49399 49.3434 4.0144 48.8842 4.4889C47.6904 5.69809 46.4506 6.86136 45.2107 8.02464C45.073 8.16239 44.9199 8.25423 44.7516 8.37668C45.6087 9.92261 46.0526 11.5145 46.0373 13.2135C45.9914 20.1166 38.3842 24.5554 32.3841 21.1574C31.9709 20.9278 31.7259 20.9125 31.4198 21.2798C31.1137 21.6625 30.7617 22.0145 30.379 22.4278C33.18 24.3411 36.2719 24.8768 39.7617 24.0809C39.6087 24.8309 39.5474 25.5044 39.3485 26.1472C39.0423 27.1115 38.6597 28.0452 38.2923 28.9789C38.2158 29.1779 38.0627 29.3768 37.8944 29.5299C35.9199 31.5197 33.93 33.4942 31.9402 35.484C31.1749 36.2493 30.578 36.28 29.7361 35.5759C27.532 33.7391 25.3432 31.8871 23.1545 30.0503C23.0167 29.9432 22.8942 29.836 22.7106 29.6983C22.2514 30.234 21.7922 30.7544 21.3177 31.3054C22.3891 32.2085 23.5677 33.2187 24.7769 34.2136C25.083 34.4585 25.2208 34.7187 25.2208 35.132C25.2514 39.3106 21.7922 42.2035 17.6136 41.53C15.9452 41.2545 14.4299 40.6269 13.0676 39.632C12.9452 39.5402 12.8227 39.4637 12.6544 39.3565C12.1493 39.831 11.6595 40.3055 11.1238 40.8259C12.0727 41.6371 13.0983 42.2341 14.1697 42.7545C14.4605 42.8923 14.736 43.1372 14.9044 43.4127C15.6697 44.6525 16.3432 45.9382 16.5115 47.4076C16.6799 48.9841 15.9146 49.8107 14.3381 49.7188C13.0217 49.6423 11.8431 49.1219 10.7717 48.4331C9.50129 47.6219 8.32271 46.6882 7.09821 45.8157C6.86862 45.6168 6.68494 45.4484 6.45535 45.2494Z"
        fill="black"
      />
    </svg>
  );
};
export const MaincourseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="50"
      viewBox="0 0 42 50"
      fill="none"
    >
      <path
        d="M0.116976 27.5407C13.8031 27.5407 27.4892 27.5407 41.1754 27.5407C41.1754 27.5407 41.2924 27.5407 41.2924 27.6577C41.6433 33.3895 40.0056 38.4194 35.5606 42.2796C32.7531 44.7361 29.3609 46.0228 25.6176 46.1398C22.4593 46.2568 19.301 46.2568 16.1426 46.1398C8.42224 45.9059 2.22253 40.7589 0.467902 33.2725C0.116975 31.5179 0 29.7632 0 28.0086C0 27.8916 0.116976 27.7747 0.116976 27.5407Z"
        fill="black"
      />
      <path
        d="M37.7831 25.6691C26.3195 25.6691 14.9729 25.6691 3.50927 25.6691C4.44507 25.2012 5.2639 24.9673 6.1997 24.9673C7.25248 24.8503 7.36946 24.7333 7.48643 23.7975C7.60341 22.6277 8.18829 21.9259 9.12409 21.224C10.2938 20.4052 11.6976 19.9373 13.1013 20.0543C13.6861 20.0543 14.0371 19.9373 14.388 19.3524C15.0898 18.1827 16.3766 17.5978 17.6633 17.3638C19.4179 17.0129 21.1726 17.0129 22.6933 18.1827C23.5121 18.7676 24.2139 19.0015 25.2667 18.7676C27.0213 18.4166 28.776 18.7676 30.2967 19.8203C30.9985 20.2882 31.4664 20.9901 31.7004 21.8089C31.9343 22.5108 32.0513 22.6277 32.8701 22.7447C34.0399 22.7447 35.2096 23.0956 36.1454 23.6805C36.7303 24.1484 37.4322 24.7333 37.7831 25.6691Z"
        fill="black"
      />
      <path
        d="M29.8288 47.4265C29.8288 47.7775 29.8288 48.1284 29.8288 48.5963C29.7118 49.4151 29.0099 50 28.0741 50C25.9686 50 23.863 50 21.7574 50C18.95 50 16.2596 50 13.4522 50C11.6975 50 10.9957 49.0642 11.3466 47.4265C17.5463 48.2454 23.746 48.2454 29.8288 47.4265Z"
        fill="black"
      />
      <path
        d="M14.8559 0.935813C14.6219 1.28674 14.6219 1.52069 14.388 1.75464C13.3352 3.04137 13.3352 4.44508 14.388 5.73181C15.7917 7.36947 15.9087 9.47503 14.8559 11.2297C14.7389 11.3466 14.7389 11.4636 14.6219 11.5806C14.271 11.9315 13.8031 12.0485 13.3352 11.8145C12.9843 11.5806 12.8673 10.9957 13.1013 10.6448C14.0371 9.00712 13.9201 8.18829 12.7503 6.66761C11.3466 4.796 11.4636 2.10557 13.1013 0.584886C13.4522 0.350935 13.8031 0.116984 14.154 0.350935C14.388 0.350935 14.6219 0.701862 14.8559 0.935813Z"
        fill="black"
      />
      <path
        d="M21.7574 0.935807C21.6405 1.28673 21.5235 1.52068 21.4065 1.63766C20.2368 3.04137 20.2368 4.3281 21.4065 5.61483C22.8102 7.25248 22.9272 9.47502 21.6405 11.2297C21.2895 11.8145 20.7047 11.9315 20.2368 11.6976C19.7689 11.3466 19.7689 10.8787 20.1198 10.2938C20.9386 9.12409 20.8216 7.83736 19.7689 6.66761C18.2482 4.796 18.2482 2.10556 19.8858 0.467905C20.2368 0.116979 20.5877 -0.116972 21.0556 0.233954C21.4065 0.35093 21.5235 0.701856 21.7574 0.935807Z"
        fill="black"
      />
      <path
        d="M27.8402 0C28.0741 0.233951 28.4251 0.467902 28.542 0.701853C28.776 1.05278 28.659 1.40371 28.3081 1.75463C27.8402 2.33951 27.4892 2.92439 27.4892 3.74322C27.4892 4.56204 27.8402 5.2639 28.3081 5.96575C29.5948 7.60341 29.7118 9.94292 28.542 11.5806C28.4251 11.8145 28.1911 12.0485 27.9571 12.0485C27.6062 12.0485 27.2553 11.9315 27.0213 11.6976C26.9044 11.4636 26.7874 10.9957 27.0213 10.7617C27.9571 9.35804 27.7232 8.07131 26.6704 6.78458C25.1497 5.02995 25.3837 2.33951 27.0213 0.701853C27.2553 0.350927 27.4892 0.233951 27.8402 0Z"
        fill="black"
      />
    </svg>
  );
};
export const DessertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="50"
      viewBox="0 0 35 50"
      fill="none"
    >
      <path
        d="M17.0191 0.0130514C17.4106 0.104411 17.8022 0.18272 18.1937 0.300183C20.9084 1.16158 22.6181 2.98878 23.336 5.74263C23.3751 5.89924 23.3751 6.05586 23.4012 6.22553C22.7617 6.12112 22.1483 6.01671 21.5479 5.9384C19.9817 5.75568 18.4678 6.00365 16.993 6.51266C16.7711 6.59097 16.484 6.60402 16.249 6.56487C15.1658 6.38215 14.0825 6.13417 12.9862 5.9645C11.6288 5.75568 10.2976 5.92535 8.90108 6.27773C8.95329 5.97755 8.97939 5.71652 9.0577 5.4816C9.9713 2.50587 11.9421 0.691725 15.0091 0.09136C15.1005 0.0783085 15.1919 0.0261028 15.2702 0C15.8575 0.0130514 16.4448 0.0130514 17.0191 0.0130514Z"
        fill="black"
      />
      <path
        d="M32.3414 17.6977C32.3284 21.1172 32.6286 24.5106 31.3104 27.7343C28.8828 33.6857 24.4975 37.1704 18.1284 38.1362C17.9718 38.1624 17.8152 38.2015 17.6586 38.2276C17.6586 40.1984 17.6586 42.1561 17.6586 44.166C19.6424 43.9963 21.3652 44.4662 22.592 46.1237C23.4534 47.2722 23.597 48.5904 23.4926 50C18.6244 50 13.7562 50 8.86192 50C8.6792 48.3425 8.97938 46.8154 10.2062 45.5756C11.433 44.3357 12.9731 44.0355 14.6698 44.166C14.6698 42.1561 14.6698 40.2114 14.6698 38.2537C13.7954 38.084 12.9079 37.9666 12.0595 37.7186C5.54685 35.7609 1.48786 31.48 0.27408 24.7716C-0.130514 22.5267 0.0652571 20.1644 0 17.8543C0 17.8152 0.0261028 17.763 0.0522057 17.6716C0.221874 17.6716 0.391543 17.6716 0.574263 17.6716C5.18142 17.6716 9.78857 17.6716 14.3957 17.6716C15.6095 17.6716 16.1446 18.2067 16.1577 19.4205C16.1707 20.0731 16.1446 20.7256 16.249 21.3652C16.6014 23.5839 18.5983 25.137 20.8562 25.0065C23.0619 24.876 24.8499 23.0619 24.9543 20.8431C24.9804 20.3211 24.9543 19.799 24.9674 19.2769C24.9935 18.2198 25.5677 17.6586 26.6249 17.6586C28.3607 17.6586 30.1096 17.6586 31.8455 17.6586C32.0021 17.6847 32.1457 17.6977 32.3414 17.6977Z"
        fill="black"
      />
      <path
        d="M13.4038 14.7351C13.8215 12.0856 16.3404 8.88803 20.5299 8.83582C23.9755 8.78362 27.2644 11.4592 27.7212 14.7351C27.3297 14.7351 26.9512 14.7351 26.5596 14.7351C23.9363 14.7481 22.0439 16.6275 22.0047 19.2509C22.0047 19.7077 22.0177 20.1645 22.0047 20.6213C21.9786 21.4565 21.3521 22.083 20.556 22.0961C19.7729 22.0961 19.1073 21.4565 19.0812 20.6343C19.0551 20.1123 19.0812 19.5902 19.0681 19.0681C19.0159 16.7319 17.2279 14.8656 14.8917 14.7481C14.4218 14.722 13.9259 14.7351 13.4038 14.7351Z"
        fill="black"
      />
      <path
        d="M13.1819 9.03158C11.6419 10.663 10.7283 12.5424 10.3759 14.6959C8.43121 14.6959 6.5257 14.6959 4.60714 14.6959C5.14225 11.0546 9.18819 8.09188 13.1819 9.03158Z"
        fill="black"
      />
      <path
        d="M32.8243 0.574263C33.4508 1.20073 34.1164 1.86635 34.7429 2.49282C32.5502 4.69851 30.3315 6.91725 28.1258 9.12294C27.4341 8.56173 26.6901 7.94832 26.0115 7.3871C28.2563 5.14226 30.5403 2.85826 32.8243 0.574263Z"
        fill="black"
      />
    </svg>
  );
};
export const PlayStoreIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="168"
      height="50"
      viewBox="0 0 168 50"
      fill="none"
    >
      <path
        d="M161.77 50H6.22C4.5676 49.9921 2.98559 49.3301 1.81996 48.1588C0.654341 46.9876 -1.90356e-05 45.4024 4.15319e-10 43.75V6.25C0.00260466 4.59838 0.657811 3.01472 1.82287 1.84405C2.98792 0.67337 4.56842 0.0105514 6.22 0H161.77C163.423 0.00792127 165.006 0.669579 166.174 1.84054C167.341 3.0115 167.997 4.59666 168 6.25V43.75C168 45.4041 167.344 46.9908 166.176 48.1624C165.009 49.3339 163.424 49.9947 161.77 50Z"
        fill="black"
      />
      <path
        d="M60.26 16.38H64.86V15.21H61.46V13.08H64.53V11.93H61.46V9.8H64.86V8.63H60.26V16.38Z"
        fill="white"
      />
      <path
        d="M65.62 9.8H67.7V16.38H68.91V9.8H71V8.63H65.62V9.8Z"
        fill="white"
      />
      <path d="M74.46 8.63V16.38H75.67V8.63H74.46Z" fill="white" />
      <path
        d="M76.63 9.8H78.72V16.38H79.92V9.8H82.01V8.63H76.63V9.8Z"
        fill="white"
      />
      <path
        d="M91.68 9.64C90.9323 8.90709 89.927 8.49657 88.88 8.49657C87.833 8.49657 86.8277 8.90709 86.08 9.64C85.7123 10.0186 85.4231 10.4662 85.2292 10.9571C85.0353 11.4479 84.9404 11.9723 84.95 12.5C84.939 13.0294 85.0333 13.5556 85.2273 14.0483C85.4212 14.541 85.7111 14.9902 86.08 15.37C86.4515 15.7419 86.8927 16.0369 87.3783 16.2382C87.8639 16.4395 88.3844 16.5431 88.91 16.5431C89.4357 16.5431 89.9562 16.4395 90.4418 16.2382C90.9274 16.0369 91.3685 15.7419 91.74 15.37C92.1089 14.9902 92.3988 14.541 92.5928 14.0483C92.7868 13.5556 92.881 13.0294 92.87 12.5C92.8718 11.9681 92.7674 11.4412 92.5631 10.9501C92.3588 10.459 92.0586 10.0136 91.68 9.64ZM88.86 15.37C88.4988 15.3788 88.1397 15.3122 87.8057 15.1744C87.4717 15.0367 87.17 14.8308 86.92 14.57C86.6549 14.2965 86.4482 13.972 86.3124 13.6161C86.1766 13.2603 86.1145 12.8806 86.13 12.5C86.1153 12.121 86.1778 11.743 86.3136 11.3889C86.4494 11.0348 86.6557 10.712 86.92 10.44C87.1739 10.1836 87.476 9.98007 87.809 9.84117C88.142 9.70227 88.4992 9.63075 88.86 9.63075C89.2208 9.63075 89.578 9.70227 89.911 9.84117C90.244 9.98007 90.5462 10.1836 90.8 10.44C91.0643 10.712 91.2707 11.0348 91.4065 11.3889C91.5423 11.743 91.6047 12.121 91.59 12.5C91.6055 12.8806 91.5435 13.2603 91.4076 13.6161C91.2718 13.972 91.0651 14.2965 90.8 14.57C90.55 14.8308 90.2483 15.0367 89.9143 15.1744C89.5803 15.3122 89.2212 15.3788 88.86 15.37Z"
        fill="white"
      />
      <path
        d="M126.69 21.88H121.08V37.5H123.4V31.58H126.65C127.313 31.6226 127.978 31.5288 128.603 31.3043C129.229 31.0799 129.801 30.7295 130.286 30.275C130.771 29.8205 131.157 29.2714 131.421 28.6616C131.685 28.0519 131.822 27.3945 131.822 26.73C131.822 26.0655 131.685 25.4081 131.421 24.7984C131.157 24.1886 130.771 23.6395 130.286 23.185C129.801 22.7305 129.229 22.3801 128.603 22.1557C127.978 21.9312 127.313 21.8374 126.65 21.88H126.69ZM126.75 29.41H123.44V24.05H126.75C127.461 24.05 128.142 24.3324 128.645 24.8349C129.148 25.3375 129.43 26.0192 129.43 26.73C129.43 27.4408 129.148 28.1224 128.645 28.625C128.142 29.1276 127.461 29.41 126.75 29.41Z"
        fill="white"
      />
      <path
        d="M73.2 27.19C72.1474 27.188 71.1178 27.4984 70.2416 28.0817C69.3655 28.6651 68.682 29.4953 68.2778 30.4672C67.8736 31.4391 67.7669 32.5091 67.971 33.5417C68.1751 34.5744 68.681 35.5232 69.4247 36.2683C70.1683 37.0133 71.1162 37.521 72.1484 37.727C73.1807 37.9331 74.2509 37.8284 75.2236 37.426C76.1962 37.0236 77.0277 36.3418 77.6127 35.4667C78.1977 34.5916 78.51 33.5626 78.51 32.51C78.5208 31.8092 78.3908 31.1134 78.1279 30.4638C77.865 29.8141 77.4744 29.2238 76.9793 28.7278C76.4842 28.2317 75.8947 27.8401 75.2455 27.5759C74.5963 27.3118 73.9008 27.1806 73.2 27.19ZM73.2 35.73C72.5529 35.7762 71.9069 35.6265 71.3462 35.3004C70.7854 34.9742 70.3358 34.4868 70.056 33.9015C69.7761 33.3163 69.679 32.6603 69.7772 32.0191C69.8755 31.3778 70.1645 30.7811 70.6067 30.3064C71.0489 29.8318 71.6238 29.5013 72.2565 29.358C72.8892 29.2147 73.5504 29.2652 74.154 29.503C74.7575 29.7408 75.2755 30.1548 75.6404 30.6912C76.0054 31.2275 76.2004 31.8613 76.2 32.51C76.2201 32.9198 76.1579 33.3294 76.0171 33.7148C75.8762 34.1001 75.6596 34.4533 75.3799 34.7535C75.1002 35.0536 74.7632 35.2947 74.3888 35.4624C74.0144 35.6302 73.6102 35.7211 73.2 35.73Z"
        fill="white"
      />
      <path
        d="M95.13 16.38V11.58L95.1 10.52L98.73 16.38H99.93V8.63H98.72V13.14L98.75 14.2L95.28 8.63H93.92V16.38H95.13Z"
        fill="white"
      />
      <path
        d="M141.08 27.16C140.231 27.1128 139.387 27.3148 138.651 27.7413C137.916 28.1677 137.321 28.7999 136.94 29.56L139 30.42C139.204 30.0446 139.514 29.7368 139.89 29.5343C140.267 29.3319 140.694 29.2435 141.12 29.28C141.412 29.251 141.706 29.2797 141.986 29.3645C142.267 29.4494 142.528 29.5886 142.754 29.7744C142.981 29.9601 143.169 30.1887 143.307 30.447C143.445 30.7054 143.531 30.9884 143.56 31.28V31.44C142.816 31.0398 141.985 30.8302 141.14 30.83C138.92 30.83 136.65 32.06 136.65 34.35C136.671 34.8323 136.789 35.3054 136.997 35.7413C137.204 36.1772 137.497 36.567 137.858 36.8878C138.219 37.2085 138.64 37.4536 139.098 37.6086C139.555 37.7636 140.039 37.8252 140.52 37.79C141.112 37.8322 141.704 37.712 142.233 37.4424C142.762 37.1727 143.207 36.7639 143.52 36.26H143.6V37.47H145.84V31.47C145.82 28.71 143.76 27.16 141.08 27.16ZM140.8 35.73C140.04 35.73 138.98 35.35 138.98 34.4C138.98 33.2 140.3 32.73 141.44 32.73C142.182 32.7065 142.916 32.89 143.56 33.26C143.476 33.9321 143.153 34.5516 142.65 35.0052C142.147 35.4587 141.497 35.716 140.82 35.73H140.8Z"
        fill="white"
      />
      <path
        d="M59.41 28.82V31.08H64.78C64.7021 32.1364 64.2726 33.1362 63.56 33.92C63.0221 34.47 62.3749 34.901 61.66 35.1852C60.9452 35.4694 60.1787 35.6005 59.41 35.57C57.8187 35.57 56.2926 34.9379 55.1674 33.8126C54.0421 32.6874 53.41 31.1613 53.41 29.57C53.41 27.9787 54.0421 26.4526 55.1674 25.3274C56.2926 24.2021 57.8187 23.57 59.41 23.57C60.92 23.549 62.3766 24.128 63.46 25.18L65.08 23.64C64.3421 22.9023 63.4635 22.3203 62.4964 21.9287C61.5293 21.537 60.4933 21.3436 59.45 21.36C58.3653 21.36 57.2912 21.5737 56.289 21.9888C55.2869 22.4039 54.3763 23.0123 53.6093 23.7793C52.8423 24.5463 52.2339 25.4569 51.8188 26.459C51.4037 27.4612 51.19 28.5353 51.19 29.62C51.19 30.7047 51.4037 31.7788 51.8188 32.781C52.2339 33.7831 52.8423 34.6937 53.6093 35.4607C54.3763 36.2277 55.2869 36.8361 56.289 37.2512C57.2912 37.6663 58.3653 37.88 59.45 37.88C60.5709 37.8827 61.6788 37.6393 62.6953 37.167C63.7119 36.6948 64.6125 36.0052 65.3334 35.1469C66.0544 34.2886 66.5782 33.2825 66.8679 32.1997C67.1576 31.1168 67.2061 29.9836 67.01 28.88L59.41 28.82Z"
        fill="white"
      />
      <path
        d="M153.99 27.51L151.33 34.28H151.24L148.48 27.51H145.98L150.12 36.98L147.76 42.24H150.18L156.57 27.51H153.99Z"
        fill="white"
      />
      <path
        d="M115.79 30.58C115.476 29.6175 114.872 28.7754 114.061 28.1687C113.25 27.562 112.272 27.2202 111.26 27.19C110.576 27.1886 109.898 27.3277 109.27 27.5988C108.641 27.8698 108.075 28.267 107.606 28.7657C107.138 29.2645 106.776 29.8541 106.545 30.4982C106.313 31.1422 106.216 31.827 106.26 32.51C106.242 33.6491 106.593 34.7636 107.261 35.6863C107.929 36.6091 108.878 37.2904 109.966 37.6283C111.054 37.9662 112.223 37.9424 113.296 37.5605C114.369 37.1786 115.29 36.4592 115.92 35.51L114.12 34.3C113.852 34.7522 113.47 35.1261 113.012 35.3841C112.554 35.6421 112.036 35.7752 111.51 35.77C110.971 35.7905 110.438 35.6478 109.981 35.3606C109.524 35.0733 109.165 34.6549 108.95 34.16L116.08 31.18L115.79 30.58ZM108.58 32.35C108.553 31.9642 108.603 31.5769 108.728 31.2108C108.853 30.8448 109.05 30.5074 109.307 30.2186C109.564 29.9297 109.876 29.6952 110.226 29.5289C110.575 29.3625 110.954 29.2677 111.34 29.25C111.749 29.21 112.161 29.297 112.518 29.4992C112.876 29.7014 113.163 30.009 113.34 30.38L108.58 32.35Z"
        fill="white"
      />
      <path d="M135.39 21.88H133.07V37.51H135.39V21.88Z" fill="white" />
      <path
        d="M99.01 28.38H98.93C98.5782 27.995 98.1481 27.6897 97.6687 27.4845C97.1892 27.2792 96.6714 27.1788 96.15 27.19C94.7955 27.2731 93.5236 27.8698 92.5938 28.8583C91.664 29.8469 91.1464 31.1529 91.1464 32.51C91.1464 33.8671 91.664 35.1731 92.5938 36.1617C93.5236 37.1502 94.7955 37.7469 96.15 37.83C96.672 37.8451 97.191 37.7465 97.671 37.5411C98.1511 37.3356 98.5807 37.0281 98.93 36.64H99.01V37.4C99.01 39.4 97.93 40.52 96.19 40.52C95.6083 40.5083 95.0434 40.3231 94.5676 39.9881C94.0919 39.6532 93.7271 39.1837 93.52 38.64L91.52 39.49C91.8986 40.4188 92.5447 41.2141 93.3762 41.7749C94.2076 42.3358 95.1871 42.6369 96.19 42.64C98.91 42.64 101.19 41.03 101.19 37.1V27.52H99.01V28.38ZM96.35 35.73C95.9386 35.7309 95.5315 35.6472 95.1538 35.4841C94.7762 35.321 94.4361 35.0819 94.1547 34.7818C93.8734 34.4817 93.6567 34.1269 93.5183 33.7396C93.3799 33.3522 93.3226 32.9405 93.35 32.53C93.3271 32.1186 93.3872 31.7068 93.5269 31.3191C93.6665 30.9315 93.8827 30.5759 94.1626 30.2735C94.4426 29.9712 94.7805 29.7283 95.1563 29.5593C95.5321 29.3904 95.9381 29.2988 96.35 29.29C96.7496 29.3127 97.1407 29.4151 97.5001 29.5913C97.8596 29.7674 98.1801 30.0137 98.4429 30.3156C98.7057 30.6175 98.9054 30.969 99.0303 31.3493C99.1552 31.7296 99.2027 32.1311 99.17 32.53C99.1971 32.9257 99.1455 33.3229 99.0181 33.6986C98.8907 34.0742 98.69 34.4209 98.4278 34.7185C98.1655 35.0161 97.8468 35.2587 97.4902 35.4323C97.1336 35.606 96.746 35.7071 96.35 35.73Z"
        fill="white"
      />
      <path
        d="M84.79 27.19C83.7366 27.1841 82.7051 27.491 81.8262 28.072C80.9474 28.6529 80.2609 29.4817 79.8536 30.4533C79.4464 31.4248 79.3367 32.4954 79.5386 33.5294C79.7405 34.5633 80.2448 35.5141 80.9876 36.2611C81.7304 37.0081 82.6783 37.5178 83.711 37.7255C84.7438 37.9332 85.815 37.8296 86.7889 37.4278C87.7627 37.0261 88.5954 36.3442 89.1813 35.4687C89.7672 34.5932 90.08 33.5635 90.08 32.51C90.0907 31.8109 89.9614 31.1168 89.6997 30.4685C89.4381 29.8202 89.0493 29.2308 88.5563 28.735C88.0634 28.2392 87.4762 27.8471 86.8293 27.5818C86.1825 27.3165 85.4891 27.1832 84.79 27.19ZM84.79 35.73C84.1429 35.7762 83.497 35.6265 82.9362 35.3003C82.3754 34.9742 81.9258 34.4868 81.646 33.9015C81.3661 33.3163 81.269 32.6603 81.3673 32.0191C81.4655 31.3778 81.7545 30.781 82.1967 30.3064C82.639 29.8318 83.2138 29.5013 83.8465 29.358C84.4792 29.2147 85.1404 29.2652 85.744 29.503C86.3475 29.7408 86.8655 30.1548 87.2305 30.6912C87.5954 31.2275 87.7904 31.8613 87.79 32.51C87.8101 32.9198 87.748 33.3294 87.6071 33.7148C87.4662 34.1001 87.2496 34.4533 86.9699 34.7534C86.6902 35.0536 86.3532 35.2947 85.9788 35.4624C85.6044 35.6302 85.2002 35.7211 84.79 35.73Z"
        fill="white"
      />
      <path d="M105.15 21.88H102.82V37.51H105.15V21.88Z" fill="white" />
      <path
        d="M13.08 9.52C12.8483 9.76615 12.6701 10.0576 12.5565 10.376C12.4429 10.6943 12.3965 11.0328 12.42 11.37V38.64C12.3806 39.2746 12.5844 39.9004 12.99 40.39L13.08 40.48C13.381 40.752 13.7745 40.8986 14.18 40.89C14.6747 40.8705 15.1563 40.726 15.58 40.47L33.63 30.17L39.84 26.64C40.1672 26.4889 40.455 26.264 40.6805 25.9829C40.9061 25.7018 41.0634 25.3722 41.14 25.02C41.0634 24.6678 40.9061 24.3382 40.6805 24.0571C40.455 23.776 40.1672 23.5511 39.84 23.4L33.63 19.84L15.57 9.53C15.1463 9.27398 14.6647 9.12948 14.17 9.11C13.7645 9.10135 13.371 9.24802 13.07 9.52H13.08Z"
        fill="#00C1FF"
      />
      <path
        d="M13.08 40.49L12.99 40.4C12.5784 39.9093 12.3708 39.2793 12.41 38.64V11.37C12.3878 11.0321 12.4358 10.6932 12.5511 10.3748C12.6665 10.0564 12.8465 9.76531 13.08 9.52L28.49 25L13.08 40.49Z"
        fill="url(#paint0_linear_743_283)"
      />
      <path
        d="M33.63 30.17L28.49 25L33.63 19.84L39.84 23.38C40.1672 23.5311 40.4549 23.756 40.6805 24.0371C40.9061 24.3182 41.0634 24.6478 41.14 25C41.0662 25.3558 40.9102 25.6894 40.6845 25.9742C40.4588 26.2589 40.1696 26.4869 39.84 26.64L33.63 30.18"
        fill="url(#paint1_linear_743_283)"
      />
      <path
        d="M14.17 40.9C13.7645 40.9086 13.371 40.762 13.07 40.49L28.49 25L33.63 30.17L15.57 40.48C15.1463 40.736 14.6647 40.8805 14.17 40.9Z"
        fill="url(#paint2_linear_743_283)"
      />
      <path
        d="M28.49 25L13.08 9.52C13.381 9.24802 13.7745 9.10135 14.18 9.11C14.6747 9.12948 15.1563 9.27398 15.58 9.53L33.63 19.84L28.49 25Z"
        fill="url(#paint3_linear_743_283)"
      />
      <path
        d="M12.98 40.58C12.5744 40.0904 12.3706 39.4646 12.41 38.83L12.41 38.64C12.3706 39.2746 12.5744 39.9004 12.98 40.39L13.07 40.48L12.98 40.57"
        fill="url(#paint4_linear_743_283)"
      />
      <path
        d="M33.75 30.28L33.63 30.17L39.84 26.64C40.1672 26.4889 40.455 26.264 40.6805 25.9829C40.9061 25.7018 41.0634 25.3722 41.14 25.02C41.1369 25.2406 41.0892 25.4583 41 25.66C40.7435 26.158 40.338 26.5636 39.84 26.82L33.75 30.29"
        fill="url(#paint5_linear_743_283)"
      />
      <path
        d="M41.14 25C41.0634 24.6478 40.9061 24.3182 40.6805 24.0371C40.4549 23.756 40.1672 23.5311 39.84 23.38L33.63 19.84L33.75 19.73L39.84 23.2C40.1962 23.3587 40.5041 23.6087 40.7325 23.9249C40.9608 24.241 41.1014 24.6119 41.14 25Z"
        fill="url(#paint6_linear_743_283)"
      />
      <path
        d="M12.41 11.37L12.41 10.97C12.4154 10.4091 12.617 9.86771 12.98 9.44L13.07 9.53C12.8383 9.77615 12.6601 10.0676 12.5465 10.386C12.4329 10.7043 12.3864 11.0428 12.41 11.38"
        fill="url(#paint7_linear_743_283)"
      />
      <path
        d="M59.13 12.81C59.1446 12.6136 59.1446 12.4164 59.13 12.22V12.12H55.21V13.27H57.9C57.8627 13.7554 57.6617 14.2137 57.33 14.57C57.0705 14.8349 56.7586 15.0429 56.4143 15.1806C56.07 15.3184 55.7007 15.3829 55.33 15.37C54.9606 15.3806 54.5928 15.316 54.249 15.1802C53.9052 15.0444 53.5926 14.8402 53.33 14.58C53.0558 14.3097 52.8412 13.985 52.7 13.6268C52.5588 13.2685 52.4941 12.8847 52.51 12.5C52.4978 12.1245 52.562 11.7504 52.6989 11.4005C52.8357 11.0506 53.0423 10.7322 53.3061 10.4647C53.5699 10.1971 53.8854 9.98608 54.2333 9.8443C54.5813 9.70253 54.9544 9.63302 55.33 9.64C55.7071 9.61107 56.0856 9.67318 56.4337 9.82111C56.7818 9.96903 57.0892 10.1984 57.33 10.49L57.42 10.59L58.25 9.76L58.13 9.64C57.8029 9.25652 57.3877 8.958 56.92 8.77C56.4187 8.55079 55.8772 8.43841 55.33 8.44C54.2692 8.44 53.2518 8.86143 52.5016 9.61158C51.7515 10.3617 51.33 11.3791 51.33 12.44C51.3172 12.9746 51.4144 13.5062 51.6157 14.0016C51.817 14.4971 52.118 14.9458 52.5 15.32C52.8666 15.6982 53.3069 15.9972 53.7937 16.1985C54.2805 16.3997 54.8034 16.499 55.33 16.49C55.8576 16.5078 56.3829 16.4146 56.8721 16.2165C57.3614 16.0184 57.8035 15.7198 58.17 15.34C58.8125 14.6571 59.1577 13.7472 59.13 12.81Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_743_283"
          x1="44.9763"
          y1="5.16807"
          x2="38.3279"
          y2="47.5001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.01" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.51" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_743_283"
          x1="160.048"
          y1="34.2166"
          x2="-238.528"
          y2="34.2166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.41" stopColor="#FFBD00" />
          <stop offset="0.78" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_743_283"
          x1="127.226"
          y1="10.5299"
          x2="79.5242"
          y2="133.683"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_743_283"
          x1="-50.682"
          y1="-2.25086"
          x2="-29.4263"
          y2="52.6913"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.07" stopColor="#2DA771" />
          <stop offset="0.48" stopColor="#15CF74" />
          <stop offset="0.8" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_743_283"
          x1="75.1075"
          y1="-719.722"
          x2="14.4764"
          y2="-123.912"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DE0" />
          <stop offset="0.01" stopColor="#008DE0" />
          <stop offset="0.26" stopColor="#00A7E0" />
          <stop offset="0.51" stopColor="#00B8E0" />
          <stop offset="0.76" stopColor="#00C4E0" />
          <stop offset="1" stopColor="#00C7E0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_743_283"
          x1="251.557"
          y1="44.203"
          x2="-426.409"
          y2="44.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C500" />
          <stop offset="0.41" stopColor="#E0A600" />
          <stop offset="0.78" stopColor="#E09100" />
          <stop offset="1" stopColor="#E08900" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_743_283"
          x1="251.582"
          y1="46.2068"
          x2="-426.384"
          y2="46.2068"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE840" />
          <stop offset="0.41" stopColor="#FFCE40" />
          <stop offset="0.78" stopColor="#FFBC40" />
          <stop offset="1" stopColor="#FFB540" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_743_283"
          x1="-504.645"
          y1="-88.5979"
          x2="-565.392"
          y2="483.356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40B8FF" />
          <stop offset="0.01" stopColor="#40B9FF" />
          <stop offset="0.26" stopColor="#40CEFF" />
          <stop offset="0.51" stopColor="#40DDFF" />
          <stop offset="0.76" stopColor="#40E7FF" />
          <stop offset="1" stopColor="#40EAFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const AppleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="168"
      height="50"
      viewBox="0 0 168 50"
      fill="none"
    >
      <path
        d="M168 45C168 47.8 165.8 50 163.2 50H4.8C2.2 50 0 47.8 0 45V5C0 2.2 2.2 0 4.8 0H163.1C165.8 0 167.9 2.2 167.9 5L168 45Z"
        fill="black"
      />
      <path
        d="M36.9 23.7C36.9 19.6 40.2 17.7 40.4 17.6C38.5 14.8 35.5 14.4 34.5 14.4C32 14.1 29.6 15.9 28.3 15.9C27 15.9 25.1 14.4 23 14.5C20.3 14.5 17.8 16.1 16.4 18.5C13.5 23.4 15.7 30.7 18.4 34.7C19.8 36.7 21.4 38.8 23.5 38.8C25.6 38.7 26.3 37.5 28.8 37.5C31.3 37.5 32 38.8 34.1 38.8C36.3 38.8 37.7 36.8 39 34.9C40.6 32.7 41.2 30.5 41.2 30.3C41.1 30.2 36.9 28.6 36.9 23.7ZM32.8 11.8C33.9 10.4 34.7 8.6 34.4 6.7C32.8 6.8 30.8 7.8 29.7 9.1C28.7 10.3 27.8 12.2 28 14.1C29.8 14.2 31.7 13.1 32.8 11.8Z"
        fill="white"
      />
      <path
        d="M66.6 38.5H63.7L62.1 33.6H56.6L55.1 38.5H52.3L57.7 21.7H61L66.6 38.5ZM61.7 31.5L60.3 27.1C60.1 26.7 59.9 25.6 59.5 23.9H59.4C59.2 24.6 59 25.7 58.6 27.1L57.2 31.5H61.7ZM80.5 32.3C80.5 34.4 79.9 36 78.8 37.2C77.8 38.3 76.6 38.8 75.1 38.8C73.5 38.8 72.3 38.2 71.6 37.1V43.4H68.9V30.4C68.9 29.1 68.9 27.8 68.8 26.4H71.2L71.4 28.3H71.5C72.4 26.9 73.8 26.1 75.6 26.1C77 26.1 78.2 26.7 79.2 27.8C80 29 80.5 30.4 80.5 32.3ZM77.7 32.4C77.7 31.2 77.4 30.3 76.9 29.5C76.3 28.7 75.5 28.3 74.6 28.3C73.9 28.3 73.3 28.5 72.8 29C72.3 29.4 71.9 30 71.7 30.7C71.6 31 71.6 31.2 71.6 31.5V33.5C71.6 34.4 71.9 35.1 72.4 35.7C72.9 36.3 73.6 36.6 74.5 36.6C75.5 36.6 76.3 36.2 76.9 35.4C77.4 34.7 77.7 33.7 77.7 32.4ZM94.4 32.3C94.4 34.4 93.8 36 92.7 37.2C91.7 38.3 90.5 38.8 89 38.8C87.4 38.8 86.2 38.2 85.5 37.1V43.4H82.8V30.4C82.8 29.1 82.8 27.8 82.7 26.4H85.1L85.3 28.3H85.4C86.3 26.9 87.7 26.1 89.5 26.1C90.9 26.1 92.1 26.7 93.1 27.8C93.9 29 94.4 30.4 94.4 32.3ZM91.6 32.4C91.6 31.2 91.3 30.3 90.8 29.5C90.2 28.7 89.4 28.3 88.5 28.3C87.8 28.3 87.2 28.5 86.7 29C86.2 29.4 85.8 30 85.6 30.7C85.5 31 85.5 31.3 85.5 31.5V33.5C85.5 34.4 85.8 35.1 86.3 35.7C86.8 36.3 87.5 36.6 88.4 36.6C89.4 36.6 90.2 36.2 90.8 35.4C91.4 34.7 91.6 33.7 91.6 32.4ZM109.9 33.8C109.9 35.2 109.4 36.4 108.4 37.3C107.3 38.3 105.8 38.8 103.8 38.8C102 38.8 100.5 38.5 99.5 37.8L100.1 35.6C101.3 36.3 102.6 36.6 104 36.6C105 36.6 105.8 36.4 106.4 35.9C107 35.4 107.2 34.8 107.2 34.1C107.2 33.4 107 32.8 106.5 32.4C106 31.9 105.3 31.5 104.2 31.1C101.3 30 99.8 28.4 99.8 26.3C99.8 24.9 100.3 23.8 101.4 22.9C102.4 22 103.8 21.6 105.5 21.6C107 21.6 108.3 21.9 109.3 22.4L108.6 24.6C107.6 24.1 106.6 23.8 105.4 23.8C104.5 23.8 103.7 24 103.2 24.5C102.8 24.9 102.5 25.4 102.5 26C102.5 26.7 102.8 27.2 103.3 27.6C103.7 28 104.6 28.4 105.7 28.9C107.1 29.5 108.2 30.2 108.9 30.9C109.6 31.6 109.9 32.6 109.9 33.8ZM118.9 28.4H115.9V34.3C115.9 35.8 116.4 36.5 117.5 36.5C118 36.5 118.4 36.5 118.7 36.4L118.8 38.4C118.3 38.6 117.6 38.7 116.7 38.7C115.6 38.7 114.8 38.4 114.2 37.7C113.6 37.1 113.3 36 113.3 34.4V28.3H111.5V26.3H113.3V24.1L115.9 23.3V26.3H118.9V28.4ZM132.2 32.3C132.2 34.2 131.7 35.7 130.6 36.9C129.5 38.1 128 38.7 126.2 38.7C124.4 38.7 123 38.1 122 36.9C120.9 35.7 120.4 34.2 120.4 32.5C120.4 30.6 120.9 29.1 122 27.9C123.1 26.7 124.6 26.1 126.4 26.1C128.2 26.1 129.6 26.7 130.7 27.9C131.7 29 132.2 30.5 132.2 32.3ZM129.4 32.4C129.4 31.3 129.2 30.3 128.7 29.6C128.1 28.6 127.3 28.2 126.3 28.2C125.2 28.2 124.4 28.7 123.8 29.6C123.3 30.4 123.1 31.4 123.1 32.5C123.1 33.6 123.3 34.6 123.8 35.4C124.4 36.4 125.2 36.8 126.2 36.8C127.2 36.8 128 36.3 128.6 35.3C129.2 34.5 129.4 33.5 129.4 32.4ZM141 28.7C140.7 28.6 140.4 28.6 140.2 28.6C139.3 28.6 138.5 29 138 29.7C137.6 30.3 137.3 31.1 137.3 32.1V38.4H134.6V30.1C134.6 28.8 134.6 27.6 134.5 26.3H136.8L136.9 28.6H137C137.3 27.8 137.7 27.2 138.3 26.7C138.9 26.3 139.5 26.1 140.2 26.1C140.4 26.1 140.7 26.1 140.9 26.1L141 28.7ZM153 31.9C153 32.3 153 32.7 152.9 33.1H144.8C144.8 34.3 145.2 35.2 146 35.8C146.7 36.4 147.6 36.6 148.6 36.6C149.8 36.6 150.9 36.4 151.9 36L152.3 37.9C151.2 38.4 149.8 38.6 148.2 38.6C146.3 38.6 144.8 38 143.8 36.9C142.7 35.8 142.2 34.3 142.2 32.5C142.2 30.7 142.7 29.2 143.7 28C144.7 26.7 146.2 26.1 147.9 26.1C149.6 26.1 151 26.7 151.9 28C152.6 29.1 153 30.3 153 31.9ZM150.4 31.2C150.4 30.4 150.2 29.7 149.9 29.1C149.4 28.4 148.7 28 147.8 28C146.9 28 146.2 28.4 145.7 29.1C145.3 29.7 145 30.4 144.9 31.2H150.4Z"
        fill="white"
      />
      <path
        d="M55.9 15.8C55.2 15.8 54.5 15.8 54 15.7V7.6C54.8 7.5 55.5 7.4 56.3 7.4C59.4 7.4 60.8 8.9 60.8 11.4C60.8 14.3 59.1 15.8 55.9 15.8ZM56.4 8.5C56 8.5 55.6 8.5 55.3 8.6V14.8C55.5 14.8 55.8 14.8 56.2 14.8C58.2 14.8 59.4 13.7 59.4 11.5C59.4 9.5 58.3 8.5 56.4 8.5ZM65.2 15.9C63.5 15.9 62.3 14.6 62.3 12.8C62.3 11 63.5 9.7 65.3 9.7C67 9.7 68.2 10.9 68.2 12.7C68.1 14.6 67 15.9 65.2 15.9ZM65.2 10.6C64.2 10.6 63.6 11.5 63.6 12.7C63.6 13.9 64.2 14.8 65.2 14.8C66.1 14.8 66.8 13.8 66.8 12.7C66.8 11.5 66.2 10.6 65.2 10.6ZM78.1 9.8L76.2 15.7H75L74.2 13.1C74 12.5 73.8 11.8 73.7 11.2C73.6 11.8 73.4 12.5 73.2 13.1L72.4 15.7H71.2L69.4 9.8H70.8L71.5 12.6C71.7 13.3 71.8 13.9 71.9 14.5C72 14 72.2 13.4 72.4 12.6L73.2 9.8H74.3L75.1 12.6C75.3 13.3 75.5 13.9 75.6 14.6C75.7 14 75.8 13.3 76 12.6L76.7 9.8H78.1ZM84.9 15.7H83.6V12.3C83.6 11.3 83.2 10.7 82.4 10.7C81.6 10.7 81.1 11.4 81.1 12.2V15.7H79.8V11.5C79.8 11 79.8 10.4 79.8 9.8H81L81.1 10.7C81.5 10.1 82.2 9.7 83 9.7C84.2 9.7 85.1 10.7 85.1 12.2L84.9 15.7ZM88.6 15.7H87.3V7.1H88.6V15.7ZM93.4 15.9C91.7 15.9 90.5 14.6 90.5 12.8C90.5 11 91.7 9.7 93.5 9.7C95.2 9.7 96.4 10.9 96.4 12.7C96.3 14.6 95.2 15.9 93.4 15.9ZM93.4 10.6C92.4 10.6 91.8 11.5 91.8 12.7C91.8 13.9 92.4 14.8 93.4 14.8C94.3 14.8 95 13.8 95 12.7C95 11.5 94.4 10.6 93.4 10.6ZM101.6 15.7L101.5 15C101.1 15.6 100.5 15.8 99.8 15.8C98.7 15.8 98 15.1 98 14.1C98 12.6 99.3 11.9 101.5 11.9V11.8C101.5 11 101.1 10.6 100.3 10.6C99.7 10.6 99.2 10.7 98.7 11L98.4 10.1C99 9.8 99.6 9.6 100.4 9.6C102 9.6 102.7 10.4 102.7 12.1V14.3C102.7 14.9 102.7 15.4 102.8 15.7H101.6ZM101.4 12.8C99.9 12.8 99.2 13.2 99.2 14C99.2 14.6 99.6 14.9 100.1 14.9C100.8 14.9 101.4 14.4 101.4 13.7V12.8ZM109.1 15.7L109 14.7C108.6 15.4 108 15.8 107.1 15.8C105.7 15.8 104.6 14.5 104.6 12.8C104.6 10.9 105.7 9.6 107.2 9.6C108 9.6 108.6 9.9 108.9 10.4V7.1H110.2V14.2C110.2 14.8 110.2 15.3 110.2 15.8L109.1 15.7ZM108.9 12.2C108.9 11.4 108.3 10.7 107.5 10.7C106.5 10.7 105.9 11.6 105.9 12.8C105.9 14 106.5 14.8 107.5 14.8C108.3 14.8 108.9 14.1 108.9 13.2V12.2ZM118.6 15.9C116.9 15.9 115.7 14.6 115.7 12.8C115.7 11 116.9 9.7 118.7 9.7C120.4 9.7 121.6 10.9 121.6 12.7C121.6 14.6 120.4 15.9 118.6 15.9ZM118.7 10.6C117.7 10.6 117.1 11.5 117.1 12.7C117.1 13.9 117.7 14.8 118.7 14.8C119.6 14.8 120.3 13.8 120.3 12.7C120.2 11.5 119.6 10.6 118.7 10.6ZM127.4 15.7V12.3C127.4 11.3 127 10.7 126.2 10.7C125.4 10.7 124.9 11.4 124.9 12.2V15.7H123.6V11.5C123.6 11 123.6 10.4 123.6 9.8H124.8L124.9 10.7C125.3 10.1 126 9.7 126.8 9.7C128 9.7 128.9 10.7 128.9 12.2V15.7H127.4ZM136.1 10.8V13.7C136.1 14.4 136.4 14.8 136.9 14.8C137.1 14.8 137.3 14.8 137.5 14.7V15.7C137.2 15.8 136.9 15.8 136.5 15.8C135.5 15.8 134.8 15.2 134.8 13.7V10.7H134V9.7H134.9V8.7L136.2 8.3V9.8H137.7V10.8H136.1ZM144.6 15.7H143.3V12.3C143.3 11.2 142.9 10.7 142.1 10.7C141.4 10.7 140.8 11.2 140.8 12.1V15.7H139.5V7.1H140.8V10.7C141.2 10.1 141.8 9.7 142.6 9.7C143.9 9.7 144.6 10.7 144.6 12.2V15.7ZM151.8 13.1H147.8C147.8 14.2 148.6 14.9 149.7 14.9C150.3 14.9 150.8 14.8 151.3 14.6L151.5 15.5C150.9 15.7 150.3 15.9 149.5 15.9C147.6 15.9 146.5 14.7 146.5 12.9C146.5 11.1 147.6 9.7 149.3 9.7C150.8 9.7 151.8 10.8 151.8 12.5C151.8 12.7 151.8 12.9 151.8 13.1ZM150.5 12.1C150.5 11.2 150 10.5 149.2 10.5C148.4 10.5 147.8 11.2 147.8 12.1H150.5Z"
        fill="white"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H8.5C9.16304 0 9.79893 0.263392 10.2678 0.732233C10.7366 1.20107 11 1.83696 11 2.5V3H11.5C12.8807 3 14 4.11929 14 5.5V11.5C14 12.8807 12.8807 14 11.5 14H5.5C4.11929 14 3 12.8807 3 11.5V11H2.5C1.83696 11 1.20107 10.7366 0.732233 10.2678C0.263392 9.79893 0 9.16304 0 8.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233ZM5 11.5C5 11.7761 5.22386 12 5.5 12H11.5C11.7761 12 12 11.7761 12 11.5V5.5C12 5.22386 11.7761 5 11.5 5H5.5C5.22386 5 5 5.22386 5 5.5V11.5ZM9 3H5.5C4.11929 3 3 4.11929 3 5.5V9H2.5C2.36739 9 2.24022 8.94732 2.14645 8.85355C2.05268 8.75978 2 8.63261 2 8.5V2.5C2 2.36739 2.05268 2.24021 2.14645 2.14645C2.24021 2.05268 2.36739 2 2.5 2H8.5C8.63261 2 8.75978 2.05268 8.85355 2.14645C8.94732 2.24022 9 2.36739 9 2.5V3Z"
        fill="#333333"
      />
    </svg>
  );
};

export const PrintIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80546 0.805456C5.32118 0.289731 6.02065 0 6.75 0H12.75C13.4793 0 14.1788 0.289731 14.6945 0.805456C15.2103 1.32118 15.5 2.02065 15.5 2.75V6H16.75C17.4793 6 18.1788 6.28973 18.6945 6.80546C19.2103 7.32118 19.5 8.02065 19.5 8.75V12.75C19.5 13.4793 19.2103 14.1788 18.6945 14.6945C18.1788 15.2103 17.4793 15.5 16.75 15.5H15.5V16.75C15.5 18.2688 14.2688 19.5 12.75 19.5H6.75C5.23122 19.5 4 18.2688 4 16.75V15.5H2.75C2.02065 15.5 1.32118 15.2103 0.805456 14.6945C0.289731 14.1788 0 13.4793 0 12.75V8.75C0 8.02065 0.289731 7.32118 0.805456 6.80546C1.32118 6.28973 2.02065 6 2.75 6H4V2.75C4 2.02065 4.28973 1.32118 4.80546 0.805456ZM2.75 7.5C2.41848 7.5 2.10054 7.6317 1.86612 7.86612C1.6317 8.10054 1.5 8.41848 1.5 8.75V12.75C1.5 13.0815 1.6317 13.3995 1.86612 13.6339C2.10054 13.8683 2.41848 14 2.75 14H4V12.75C4 11.2312 5.23122 10 6.75 10H12.75C14.2688 10 15.5 11.2312 15.5 12.75V14H16.75C17.0815 14 17.3995 13.8683 17.6339 13.6339C17.8683 13.3995 18 13.0815 18 12.75V8.75C18 8.41848 17.8683 8.10054 17.6339 7.86612C17.3995 7.6317 17.0815 7.5 16.75 7.5H2.75ZM14 6H5.5V2.75C5.5 2.41848 5.6317 2.10054 5.86612 1.86612C6.10054 1.6317 6.41848 1.5 6.75 1.5H12.75C13.0815 1.5 13.3995 1.6317 13.6339 1.86612C13.8683 2.10054 14 2.41848 14 2.75V6ZM14 12.75C14 12.0596 13.4404 11.5 12.75 11.5H6.75C6.05964 11.5 5.5 12.0596 5.5 12.75V16.75C5.5 17.4404 6.05964 18 6.75 18H12.75C13.4404 18 14 17.4404 14 16.75V12.75Z"
        fill="#333333"
      />
    </svg>
  );
};

// --------------Loaders---------------

export const PendingLoader = () => {
  return (
    <svg className="circularLoader" viewBox="25 25 50 50">
      <circle
        className="loaderPath"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke="#F29339"
        stroke-width="2"
      />
    </svg>
  );
};

export const SuccessLoader = () => {
  return (
    <svg
      className="checkmark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
    >
      <circle
        className="checkmark__circle"
        cx="26"
        cy="26"
        r="25"
        fill="none"
      />
      <path
        className="checkmark__check"
        fill="none"
        d="M14.1 27.2l7.1 7.2 16.7-16.8"
      />
    </svg>
  );
};

// --------------------------Ecommerce Icon---------------

export const DropdownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
        fill="#333333"
      />
    </svg>
  );
};

export const ECartIcon = () => {
  return (
    <svg
      viewBox="64 64 896 896"
      focusable="false"
      data-icon="shopping"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"></path>
    </svg>
  );
};


// --------------------------------------

export const SepIcon = () => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.50052 0.0234375L16.9854 8.5091L8.50052 16.9948L0.015625 8.5091L8.50052 0.0234375Z" fill="#FDE5B9" />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6963 5.46586C13.7057 5.45741 13.715 5.44867 13.724 5.43966L13.7258 5.43791C13.8721 5.29158 13.9452 5.09986 13.9453 4.90813C13.9453 4.90798 13.9453 4.90827 13.9453 4.90813" fill="#613323" />
      <path d="M13.6963 5.46586L9.72548 9.43433C9.4325 9.72713 8.95763 9.72699 8.66482 9.43401C8.37202 9.14103 8.37216 8.66615 8.66514 8.37335L11.3824 5.65774H1.00781C0.593598 5.65774 0.257812 5.32196 0.257812 4.90774C0.257812 4.49353 0.593598 4.15774 1.00781 4.15774H11.3839L8.66514 1.44065C8.37216 1.14784 8.37202 0.672968 8.66482 0.379986C8.95763 0.0870047 9.4325 0.0868611 9.72548 0.379666L13.6964 4.34814C13.7064 4.35714 13.7162 4.36645 13.7258 4.37608C13.8723 4.52268 13.9455 4.71481 13.9453 4.90689" fill="#613323" />
    </svg>

  );
};


// ------------------suifrens icon--------------------


export const SCartIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.55913 0.529999H2.33495C1.80837 0.529999 1.37202 0.938347 1.33715 1.46377L0.629127 12.13C0.582521 12.8138 0.676997 13.4999 0.906687 14.1456C1.13638 14.7914 1.49638 15.383 1.96433 15.8838C2.43228 16.3846 2.99819 16.7838 3.62691 17.0566C4.25563 17.3295 4.93374 17.4702 5.61913 17.47H12.9991C13.6836 17.4701 14.3608 17.3297 14.9888 17.0574C15.6168 16.7852 16.1823 16.3869 16.6501 15.8872C17.1179 15.3875 17.4781 14.7971 17.7084 14.1525C17.9388 13.508 18.0343 12.823 17.9891 12.14L17.2718 1.46297C17.2365 0.937885 16.8003 0.529999 16.2741 0.529999H4.55913ZM4.55913 2.16C4.55913 1.81206 4.27707 1.53 3.92913 1.53H3.2748C2.74829 1.53 2.31196 1.93825 2.277 2.4636L1.62913 12.2C1.59214 12.7467 1.66788 13.2952 1.85164 13.8114C2.0354 14.3276 2.32326 14.8006 2.69738 15.201C3.07149 15.6013 3.52388 15.9206 4.02648 16.1389C4.52908 16.3572 5.07117 16.4699 5.61913 16.47H12.9991C13.5479 16.4713 14.0911 16.3596 14.5949 16.1419C15.0987 15.9242 15.5523 15.6052 15.9275 15.2046C16.3027 14.8041 16.5914 14.3307 16.7758 13.8138C16.9601 13.2969 17.0362 12.7475 16.9991 12.2L16.3421 2.46267C16.3066 1.93771 15.8705 1.53 15.3443 1.53H14.6891C14.3412 1.53 14.0591 1.81206 14.0591 2.16C14.0591 2.78378 13.9363 3.40145 13.6976 3.97775C13.4588 4.55404 13.109 5.07768 12.6679 5.51876C12.2268 5.95983 11.7032 6.30972 11.1269 6.54843C10.5506 6.78714 9.93291 6.91 9.30913 6.91C8.68535 6.91 8.06768 6.78714 7.49138 6.54843C6.91508 6.30972 6.39145 5.95983 5.95037 5.51876C5.50929 5.07768 5.15941 4.55404 4.9207 3.97775C4.68199 3.40145 4.55913 2.78378 4.55913 2.16ZM13.0591 2.16C13.0591 1.81206 12.7771 1.53 12.4291 1.53H6.18913C5.84119 1.53 5.55913 1.81206 5.55913 2.16C5.55913 3.15456 5.95422 4.10839 6.65748 4.81165C7.36074 5.51491 8.31457 5.91 9.30913 5.91C10.3037 5.91 11.2575 5.51491 11.9608 4.81165C12.664 4.10839 13.0591 3.15456 13.0591 2.16Z" fill="black" stroke="black"></path>
    </svg>
  );
};
export const XIcon = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.7203 2.0625H19.7539L13.1281 9.63359L20.9227 19.9375H14.8211L10.0387 13.6898L4.57305 19.9375H1.53516L8.6207 11.8379L1.14844 2.0625H7.40469L11.723 7.77305L16.7203 2.0625ZM15.6547 18.1242H17.3348L6.48945 3.78125H4.68477L15.6547 18.1242Z" fill="black" />
    </svg>
  );
};
export const LinkedinIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6598_1433)">
        <path d="M17.875 1.375H1.3707C0.614453 1.375 0 1.99805 0 2.76289V19.2371C0 20.002 0.614453 20.625 1.3707 20.625H17.875C18.6313 20.625 19.25 20.002 19.25 19.2371V2.76289C19.25 1.99805 18.6313 1.375 17.875 1.375ZM5.81797 17.875H2.96484V8.68828H5.82227V17.875H5.81797ZM4.39141 7.43359C3.47617 7.43359 2.73711 6.69023 2.73711 5.7793C2.73711 4.86836 3.47617 4.125 4.39141 4.125C5.30234 4.125 6.0457 4.86836 6.0457 5.7793C6.0457 6.69453 5.30664 7.43359 4.39141 7.43359ZM16.5129 17.875H13.6598V13.4062C13.6598 12.3406 13.6383 10.9699 12.1773 10.9699C10.6906 10.9699 10.4629 12.1301 10.4629 13.3289V17.875H7.60977V8.68828H10.3469V9.94297H10.3855C10.768 9.22109 11.7004 8.46055 13.0883 8.46055C15.9758 8.46055 16.5129 10.3641 16.5129 12.8391V17.875Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6598_1433">
          <rect width="19.25" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FacebookIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6598_1435)">
        <path d="M3 1.375C1.4832 1.375 0.25 2.6082 0.25 4.125V17.875C0.25 19.3918 1.4832 20.625 3 20.625H7.21953V14.3602H4.95078V11H7.21953V9.55195C7.21953 5.80938 8.9125 4.07344 12.5906 4.07344C13.2867 4.07344 14.4898 4.21094 14.984 4.34844V7.39062C14.7262 7.36484 14.275 7.34766 13.7121 7.34766C11.9074 7.34766 11.2113 8.03086 11.2113 9.80547V11H14.8035L14.1848 14.3602H11.207V20.625H16.75C18.2668 20.625 19.5 19.3918 19.5 17.875V4.125C19.5 2.6082 18.2668 1.375 16.75 1.375H3Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6598_1435">
          <rect width="19.25" height="22" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const PinterestIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6598_1437)">
        <path d="M17 1.375H3.25C1.7332 1.375 0.5 2.6082 0.5 4.125V17.875C0.5 19.3918 1.7332 20.625 3.25 20.625H6.36953L6.275 20.5906C6.04297 18.5238 6.1418 18.1199 6.94961 14.8027C7.11719 14.1152 7.31484 13.2988 7.54688 12.3148C7.54688 12.3148 7.2332 11.6789 7.2332 10.7465C7.2332 7.70859 10.4773 7.39492 10.4773 9.67227C10.4773 10.2523 10.2453 11.0086 9.99609 11.8121C9.8543 12.2676 9.7125 12.7359 9.60508 13.1871C9.36016 14.2398 10.1336 15.0949 11.1691 15.0949C13.0469 15.0949 14.4863 13.1184 14.4863 10.2652C14.4863 7.73867 12.6687 5.97266 10.0777 5.97266C7.07422 5.97266 5.3125 8.22422 5.3125 10.5531C5.3125 11.4598 5.66484 12.4309 6.09883 12.9594C6.18477 13.0625 6.19766 13.1527 6.17188 13.2602C6.12461 13.4621 6.03867 13.8145 5.96992 14.0852C5.92695 14.257 5.89258 14.3988 5.87969 14.4547C5.83242 14.648 5.7293 14.691 5.52734 14.5965C4.2125 13.982 3.3875 12.057 3.3875 10.5102C3.3875 7.18008 5.80234 4.125 10.357 4.125C14.018 4.125 16.8625 6.7332 16.8625 10.218C16.8625 13.8531 14.5723 16.7793 11.3883 16.7793C10.3184 16.7793 9.31289 16.225 8.96914 15.5676C8.96914 15.5676 8.44063 17.5828 8.31172 18.077C8.09688 18.9063 7.55547 19.9203 7.13437 20.625H17C18.5168 20.625 19.75 19.3918 19.75 17.875V4.125C19.75 2.6082 18.5168 1.375 17 1.375Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6598_1437">
          <rect width="19.25" height="22" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MediumIcon = () => {
  return (
    <svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6598_1439)">
        <path d="M8.50586 3.19336C4.22188 3.19336 0.75 6.68672 0.75 11.0008C0.75 15.3148 4.22188 18.8082 8.50586 18.8082C12.7898 18.8082 16.2617 15.3148 16.2617 11.0008C16.2617 6.68672 12.7898 3.19336 8.50586 3.19336ZM20.8937 3.64883C18.7539 3.64883 17.018 6.94023 17.018 11.0008C17.018 15.0613 18.7539 18.3527 20.898 18.3527C23.0422 18.3527 24.7781 15.0613 24.7781 11.0008H24.7695C24.7695 6.94023 23.0336 3.64883 20.8937 3.64883ZM26.8879 4.41367C26.1359 4.41367 25.5258 7.36133 25.5258 11.0008C25.5258 14.6402 26.1359 17.5879 26.8879 17.5879C27.6398 17.5879 28.25 14.6359 28.25 11.0008C28.25 7.36562 27.6398 4.41367 26.8879 4.41367Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6598_1439">
          <rect width="27.5" height="22" fill="white" transform="translate(0.75)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const InstagramIcon = () => {
  return (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6598_1441)">
        <path d="M8.60312 9.09648C8.35287 9.26379 8.13802 9.47875 7.97084 9.72909C7.80366 9.97943 7.68742 10.2602 7.62877 10.5555C7.51031 11.1518 7.63359 11.7708 7.97148 12.2762C8.30938 12.7816 8.8342 13.1321 9.43051 13.2505C10.0268 13.369 10.6458 13.2457 11.1512 12.9078C11.6566 12.5699 12.0071 12.0451 12.1255 11.4488C12.244 10.8525 12.1207 10.2335 11.7828 9.72812C11.4449 9.22271 10.9201 8.87223 10.3238 8.75377C9.72748 8.63531 9.10854 8.75859 8.60312 9.09648ZM14.7176 6.15742C14.4941 5.93398 14.2234 5.75781 13.927 5.6418C13.1492 5.33672 11.452 5.34961 10.3562 5.3625C10.1801 5.3625 10.0168 5.3668 9.875 5.3668C9.7332 5.3668 9.56563 5.3668 9.38516 5.3625C8.28945 5.34961 6.60078 5.33242 5.82305 5.6418C5.52656 5.75781 5.26016 5.93398 5.03242 6.15742C4.80469 6.38086 4.63281 6.65156 4.5168 6.94805C4.21172 7.72578 4.22891 9.42734 4.2375 10.523C4.2375 10.6992 4.2418 10.8625 4.2418 11C4.2418 11.1375 4.2418 11.3008 4.2375 11.477C4.22891 12.5727 4.21172 14.2742 4.5168 15.052C4.63281 15.3484 4.80898 15.6148 5.03242 15.8426C5.25586 16.0703 5.52656 16.2422 5.82305 16.3582C6.60078 16.6633 8.29805 16.6504 9.39375 16.6375C9.56992 16.6375 9.7332 16.6332 9.875 16.6332C10.0168 16.6332 10.1844 16.6332 10.3648 16.6375C11.4605 16.6504 13.1492 16.6676 13.927 16.3582C14.2234 16.2422 14.4898 16.066 14.7176 15.8426C14.9453 15.6191 15.1172 15.3484 15.2332 15.052C15.5426 14.2785 15.5254 12.5855 15.5125 11.4855C15.5125 11.3051 15.5082 11.1375 15.5082 10.9957C15.5082 10.8539 15.5082 10.6906 15.5125 10.5059C15.5254 9.41016 15.5426 7.71719 15.2332 6.93945C15.1172 6.64297 14.941 6.37656 14.7176 6.14883V6.15742ZM11.8344 8.06953C12.6116 8.58919 13.1505 9.39631 13.3326 10.3133C13.5148 11.2304 13.3251 12.1822 12.8055 12.9594C12.5482 13.3442 12.2176 13.6746 11.8326 13.9317C11.4476 14.1887 11.0157 14.3675 10.5617 14.4576C9.64464 14.6398 8.69283 14.4501 7.91562 13.9305C7.13842 13.4114 6.59925 12.6048 6.41673 11.6882C6.23421 10.7716 6.42329 9.81998 6.94238 9.04277C7.46147 8.26556 8.26804 7.7264 9.18467 7.54388C10.1013 7.36136 11.0529 7.55044 11.8301 8.06953H11.8344ZM13.0891 8.01367C12.9559 7.92344 12.8484 7.79453 12.784 7.64414C12.7195 7.49375 12.7066 7.33047 12.7367 7.16719C12.7668 7.00391 12.8484 6.86211 12.9602 6.74609C13.0719 6.63008 13.2223 6.55273 13.3813 6.52266C13.5402 6.49258 13.7078 6.50547 13.8582 6.56992C14.0086 6.63437 14.1375 6.7375 14.2277 6.8707C14.318 7.00391 14.3652 7.16289 14.3652 7.32617C14.3652 7.43359 14.3438 7.54102 14.3051 7.63984C14.2664 7.73867 14.202 7.82891 14.1289 7.90625C14.0559 7.98359 13.9613 8.04375 13.8625 8.08672C13.7637 8.12969 13.6562 8.15117 13.5488 8.15117C13.3855 8.15117 13.2266 8.10391 13.0934 8.01367H13.0891ZM19.5 4.125C19.5 2.6082 18.2668 1.375 16.75 1.375H3C1.4832 1.375 0.25 2.6082 0.25 4.125V17.875C0.25 19.3918 1.4832 20.625 3 20.625H16.75C18.2668 20.625 19.5 19.3918 19.5 17.875V4.125ZM15.5898 16.7148C14.7863 17.5184 13.8109 17.7719 12.7109 17.8277C11.5766 17.8922 8.17344 17.8922 7.03906 17.8277C5.93906 17.7719 4.96367 17.5184 4.16016 16.7148C3.35664 15.9113 3.10312 14.9359 3.05156 13.8359C2.98711 12.7016 2.98711 9.29844 3.05156 8.16406C3.10742 7.06406 3.35664 6.08867 4.16016 5.28516C4.96367 4.48164 5.94336 4.22812 7.03906 4.17656C8.17344 4.11211 11.5766 4.11211 12.7109 4.17656C13.8109 4.23242 14.7863 4.48164 15.5898 5.28516C16.3934 6.08867 16.6469 7.06406 16.6984 8.16406C16.7629 9.29414 16.7629 12.693 16.6984 13.8316C16.6426 14.9316 16.3934 15.907 15.5898 16.7105V16.7148Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_6598_1441">
          <rect width="19.25" height="22" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const USDTIcon = () => {
  return (
    <svg
      width="111"
      height="90"
      viewBox="0 0 111 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4825 0.862305H88.0496C89.5663 0.862305 90.9675 1.64827 91.7239 2.92338L110.244 34.1419C111.204 35.7609 110.919 37.8043 109.549 39.1171L58.5729 87.9703C56.9216 89.5528 54.2652 89.5528 52.6139 87.9703L1.70699 39.1831C0.305262 37.8398 0.0427812 35.7367 1.07354 34.1077L20.8696 2.82322C21.6406 1.60483 23.0087 0.862305 24.4825 0.862305ZM79.8419 14.8003V23.5597H61.7343V29.6329C74.4518 30.2819 83.9934 32.9475 84.0642 36.1425L84.0638 42.803C83.993 45.998 74.4518 48.6635 61.7343 49.3125V64.2168H49.7105V49.3125C36.9929 48.6635 27.4513 45.998 27.3805 42.803L27.381 36.1425C27.4517 32.9475 36.9929 30.2819 49.7105 29.6329V23.5597H31.6028V14.8003H79.8419ZM55.7224 44.7367C69.2943 44.7367 80.6382 42.4827 83.4143 39.4727C81.0601 36.9202 72.5448 34.9114 61.7343 34.3597V40.7183C59.7966 40.8172 57.7852 40.8693 55.7224 40.8693C53.6595 40.8693 51.6481 40.8172 49.7105 40.7183V34.3597C38.8999 34.9114 30.3846 36.9202 28.0304 39.4727C30.8066 42.4827 42.1504 44.7367 55.7224 44.7367Z"
        fill="#009393"
      />
    </svg>
  );
};